import DOMPurify from 'dompurify'
import type { DatosReporte } from './datos'

function v(val: any): string {
  return val !== null && val !== undefined ? String(val) : ''
}

function escapeHtml(s: string): string {
  return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
}

const CSS = `
* { box-sizing: border-box; margin: 0; padding: 0; }
html, body { margin: 0; padding: 0; }
body { font-family: Arial, sans-serif; font-size: 9pt; color: #000; }
table { border-collapse: collapse; width: 100%; }
td, th { border: 1px solid #000; padding: 3px 6px; vertical-align: middle; font-size: 8.5pt; }
.bold { font-weight: bold; }
.center { text-align: center; }
.right { text-align: right; }
.small { font-size: 7.5pt; }
.text { position:absolute; z-index:3; white-space:nowrap; }
.content { padding: 0 30px 0; }
.seccion { margin-bottom: 14px; }
.no-break { page-break-inside: avoid; }
.titulo-prueba { font-size: 11pt; font-weight: bold; text-align: center; padding: 6px; }
.pdf-embed { page-break-inside: auto; }
.pdf-embed tr { page-break-inside: auto !important; break-inside: auto !important; }
.pdf-embed td { border: 1px solid #aaa !important; }
/* NMX-A-083 */
.bit083-row { page-break-inside: auto !important; break-inside: auto !important; }
.bit083-seccion-titulo { font-weight: bold; text-align: center; background: #f0f0f0; }
.no-break-header { break-inside: avoid; page-break-inside: avoid; }
.bit083-cumple { color: #166534; font-weight: bold; }
.bit083-no-cumple { color: #991b1b; font-weight: bold; }
@page {
  size: letter;
  margin: 30mm 0 22mm 0;
  @bottom-center {
    content: counter(page) " de " counter(pages);
    font-size: 8pt;
    font-family: Arial, sans-serif;
    color: #000;
  }
}
@media print {
  tr { page-break-inside: avoid; break-inside: avoid; }
}
@media screen {
  .content { padding: 15px 30px; max-width: 820px; margin: 0 auto; }
}
`

// ─── Secciones bitácora por prueba ────────────────────────────────────────

// NMX-A-3801 — params 11 cols, nested data table + REALIZÓ/AUTORIZÓ inline
function bit3801(d: any): string {
  const dataNested = `<table style="width:100%;border-collapse:collapse">
    <tr><td class="bold">NO.</td><td class="center bold">GRAMOS</td><td class="center bold">RESULTADO</td></tr>
    <tr><td>1</td><td class="center">${v(d.no1_1)}</td><td class="center">${v(d.no1_2)}</td></tr>
    <tr><td>2</td><td class="center">${v(d.no2_1)}</td><td class="center">${v(d.no2_2)}</td></tr>
    <tr><td>3</td><td class="center">${v(d.no3_1)}</td><td class="center">${v(d.no3_2)}</td></tr>
    <tr><td>4</td><td class="center">${v(d.no4_1)}</td><td class="center">${v(d.no4_2)}</td></tr>
    <tr><td>5</td><td class="center">${v(d.no5_1)}</td><td class="center">${v(d.no5_2)}</td></tr>
    <tr><td colspan="2" class="bold">PROMEDIO</td><td class="center"><b>${v(d.promedio)}</b></td></tr>
    <tr><td colspan="2" class="bold">REDONDEO</td><td class="center"><b>${v(d.redondeo)} g/m²</b></td></tr>
  </table>`
  return `<div class="seccion no-break">
  <table style="margin-top:2px">
    <tr>
      <td>NÚMERO DE SOLICITUD: ${v(d.numero_solicitud)}</td>
      <td class="right">MET 7.2-8</td>
    </tr>
  </table>
  <table><tr><td class="titulo-prueba">NMX-A-3801-INNTEX-2012 DETERMINACIÓN DE LA MASA DEL TEJIDO POR UNIDAD DE ÁREA</td></tr></table>
  <table style="margin-top:2px">
    <tr>
      <td>FECHA:</td><td>${v(d.fecha)}</td><td>HORA:</td><td>${v(d.hora)}</td>
      <td>° C:</td><td>${v(d.grados)}</td><td>% HR:</td><td>${v(d.hr)}</td>
      <td>ID DEL TERMOHIGROMETRO:</td><td>${v(d.termo)}</td>
      <td>FACTOR DE CORRECCIÓN: 100.12</td>
    </tr>
  </table>
  <table style="margin-top:2px">
    <tr>
      <td rowspan="2" style="padding:0;vertical-align:top">${dataNested}</td>
      <td>REALIZÓ: ${v(d.realizo)}</td>
    </tr>
    <tr><td>AUTORIZÓ: ${v(d.superviso)}</td></tr>
    <tr><td colspan="2" style="text-align:justify">OBSERVACIONES: ${v(d.observaciones)}</td></tr>
  </table>
  </div>`
}

// NMX-A-109 — params 8 cols, nested SECOS+HÚMEDOS tables inline, REALIZÓ/SUPERVISÓ below
function bit109(d: any): string {
  const secos = `<table style="width:100%;border-collapse:collapse">
    <tr><td class="bold">NO.</td><td class="center bold">URDIMBRE</td><td class="center bold">TRAMA</td></tr>
    <tr><td>1</td><td class="center">${v(d.no1_1)}</td><td class="center">${v(d.no1_2)}</td></tr>
    <tr><td>2</td><td class="center">${v(d.no2_1)}</td><td class="center">${v(d.no2_2)}</td></tr>
    <tr><td>3</td><td class="center">${v(d.no3_1)}</td><td class="center">${v(d.no3_2)}</td></tr>
    <tr><td>4</td><td class="center">${v(d.no4_1)}</td><td class="center">${v(d.no4_2)}</td></tr>
    <tr><td>5</td><td class="center">${v(d.no5_1)}</td><td class="center">${v(d.no5_2)}</td></tr>
    <tr><td>PROMEDIO</td><td class="center"><b>${v(d.promedio_u)} N</b></td><td class="center"><b>${v(d.promedio_t)} N</b></td></tr>
    <tr><td>( )</td><td class="center">${v(d.texto_u)}</td><td class="center">${v(d.texto_t)}</td></tr>
  </table>`
  const humedos = `<table style="width:100%;border-collapse:collapse">
    <tr><td class="bold">NO.</td><td class="center bold">URDIMBRE</td><td class="center bold">TRAMA</td></tr>
    <tr><td>1</td><td class="center">${v(d.hum_u1)}</td><td class="center">${v(d.hum_t1)}</td></tr>
    <tr><td>2</td><td class="center">${v(d.hum_u2)}</td><td class="center">${v(d.hum_t2)}</td></tr>
    <tr><td>3</td><td class="center">${v(d.hum_u3)}</td><td class="center">${v(d.hum_t3)}</td></tr>
    <tr><td>4</td><td class="center">${v(d.hum_u4)}</td><td class="center">${v(d.hum_t4)}</td></tr>
    <tr><td>5</td><td class="center">${v(d.hum_u5)}</td><td class="center">${v(d.hum_t5)}</td></tr>
    <tr><td>PROMEDIO</td><td class="center"><b>${v(d.hum_pu)} N</b></td><td class="center"><b>${v(d.hum_pt)} N</b></td></tr>
    <tr><td>( )</td><td class="center">${v(d.hum_tu)}</td><td class="center">${v(d.hum_tt)}</td></tr>
  </table>`
  return `<div class="seccion no-break">
  <table style="margin-top:2px"><tr><td>NÚMERO DE SOLICITUD: ${v(d.numero_solicitud)}</td></tr></table>
  <table><tr><td class="titulo-prueba">NMX-A-109-INNTEX-2012 RESISTENCIA AL RASGADO</td></tr></table>
  <table style="margin-top:2px">
    <tr>
      <td>FECHA</td><td>${v(d.fecha)}</td><td>HORA</td><td>${v(d.hora)}</td>
      <td>° C:</td><td>${v(d.grados)}</td><td>% HR:</td><td>${v(d.hr)}</td>
    </tr>
    <tr>
      <td colspan="2">CAPACIDAD DEL EQUIPO: ${v(d.capacidad_equipo_rr)}</td>
      <td>URDIMBRE</td><td>${v(d.urdimbre)}</td>
      <td>TRAMA</td><td>${v(d.trama)}</td>
      <td>ESPECÍMENES RECHAZADOS:</td><td>${v(d.espec_rechz_rr)}</td>
    </tr>
    <tr>
      <td>TIPO DE MATERIAL EVALUADO</td><td>${v(d.tipo_material)}</td>
      <td colspan="2">EQUIPO DIGITAL</td>
      <td>ESTADO DE LOS ESPECÍMENES:</td><td>${v(d.estado_espec_rr)}</td>
      <td>ID DEL TERMOHIGROMETRO:</td><td>${v(d.termo)}</td>
    </tr>
  </table>
  <table style="margin-top:2px">
    <tr>
      <td style="padding:0;vertical-align:top">ACONDICIONADOS<br>${secos}</td>
      <td style="padding:0;vertical-align:top">HÚMEDOS<br>${humedos}</td>
    </tr>
    <tr><td colspan="2">REALIZÓ: ${v(d.realizo)}</td></tr>
    <tr><td colspan="2">SUPERVISÓ: ${v(d.superviso)}</td></tr>
    <tr><td colspan="2" style="text-align:justify">OBSERVACIONES: ${v(d.observaciones)}</td></tr>
  </table>
  </div>`
}

// NMX-A-7211 — Bitácora: params (8 cols) + nested data table inline con REALIZÓ/SUPERVISÓ
function bit7211(d: any): string {
  const dataNested = `<table style="width:100%;border-collapse:collapse">
    <tr><td class="bold">NO.</td><td class="center bold">URDIMBRE</td><td class="center bold">TRAMA</td></tr>
    <tr><td>1</td><td class="center">${v(d.no1_1)}</td><td class="center">${v(d.no1_2)}</td></tr>
    <tr><td>2</td><td class="center">${v(d.no2_1)}</td><td class="center">${v(d.no2_2)}</td></tr>
    <tr><td>3</td><td class="center">${v(d.no3_1)}</td><td class="center">${v(d.no3_2)}</td></tr>
    <tr><td>4</td><td class="center">${v(d.no4_1)}</td><td class="center">${v(d.no4_2)}</td></tr>
    <tr><td>5</td><td class="center">${v(d.no5_1)}</td><td class="center">${v(d.no5_2)}</td></tr>
    <tr><td>PROMEDIO</td><td class="center">${v(d.promedio_u)}</td><td class="center">${v(d.promedio_t)}</td></tr>
    <tr><td>RESULTADO</td><td class="center">${v(d.suma_u)} Hilos por cm</td><td class="center">${v(d.suma_t)} Hilos por cm</td></tr>
  </table>`
  return `<div class="seccion no-break">
  <table style="margin-top:2px">
    <tr>
      <td>NUMERO DE SOLICITUD: ${v(d.numero_solicitud)}</td>
      <td class="right">MET 7.2-6</td>
    </tr>
  </table>
  <table><tr><td class="titulo-prueba">NMX-A-7211/2-INNTEX-2015 DETERMINACIÓN DEL NÚMERO DE HILOS POR UNIDAD DE LONGITUD (MÉTODO A)</td></tr></table>
  <table style="margin-top:2px">
    <tr>
      <td>FECHA</td><td>${v(d.fecha)}</td><td>HORA</td><td>${v(d.hora)}</td>
      <td>° C:</td><td>${v(d.grados)}</td><td>% HR:</td><td>${v(d.hr)}</td>
    </tr>
    <tr>
      <td colspan="2">ESPECÍMENES ENSAYADOS: ${v(d.espec_u_ma)} en U y ${v(d.espec_t_ma || d.espec_u_ma)} en T.</td>
      <td>ID DE TERMOHIGROMETRO: ${v(d.termo)}</td>
      <td>DISTANCIA DE MEDICIÓN:</td>
      <td>URDIMBRE:</td><td>${v(d.urdimbre)} cm</td>
      <td>TRAMA:</td><td>${v(d.trama)} cm</td>
    </tr>
  </table>
  <table style="margin-top:2px">
    <tr>
      <td rowspan="2" style="padding:0;vertical-align:top">${dataNested}</td>
      <td>REALIZÓ: ${v(d.realizo)}</td>
    </tr>
    <tr><td>SUPERVISÓ: ${v(d.superviso)}</td></tr>
    <tr><td colspan="2" style="text-align:justify">OBSERVACIONES: ${v(d.observaciones)}</td></tr>
  </table>
  </div>`
}

// NMX-A-134 — params 8 cols, nested data table + REALIZÓ/SUPERVISÓ inline
function bit134(d: any): string {
  const dataNested = `<table style="width:100%;border-collapse:collapse">
    <tr><td class="bold">No.</td><td class="center bold">COLUMNAS</td><td class="center bold">MALLAS</td></tr>
    <tr><td>1</td><td class="center">${v(d.no1_1)}</td><td class="center">${v(d.no1_2)}</td></tr>
    <tr><td>2</td><td class="center">${v(d.no2_1)}</td><td class="center">${v(d.no2_2)}</td></tr>
    <tr><td>3</td><td class="center">${v(d.no3_1)}</td><td class="center">${v(d.no3_2)}</td></tr>
    <tr><td>4</td><td class="center">${v(d.no4_1)}</td><td class="center">${v(d.no4_2)}</td></tr>
    <tr><td>5</td><td class="center">${v(d.no5_1)}</td><td class="center">${v(d.no5_2)}</td></tr>
    <tr><td>PROMEDIO</td><td class="center">${v(d.promedio_c)}</td><td class="center">${v(d.promedio_m)}</td></tr>
    <tr><td>RESULTADO</td><td class="center">${v(d.suma_c)}</td><td class="center">${v(d.suma_m)}</td></tr>
    <tr><td>REDONDEO</td><td class="center"><b>${v(d.redondeo_c)} Hilos por cm</b></td><td class="center"><b>${v(d.redondeo_m)} Hilos por cm</b></td></tr>
  </table>`
  return `<div class="seccion no-break">
  <table><tr><td>NÚMERO DE SOLICITUD: ${v(d.numero_solicitud)}</td><td class="bold" style="text-align:right">MET-7.2-6</td></tr></table>
  <table><tr><td class="titulo-prueba">NMX-A-134-INNTEX-2013 DENSIDAD DE TEJIDO DE PUNTO</td></tr></table>
  <table style="margin-top:2px">
    <tr>
      <td>FECHA:</td><td>${v(d.fecha)}</td><td>HORA:</td><td>${v(d.hora)}</td>
      <td>° C:</td><td>${v(d.grados)}</td><td>% HR:</td><td>${v(d.hr)}</td>
    </tr>
    <tr>
      <td colspan="2">DISTANCIA DE MEDICIÓN:</td>
      <td>COLUMNAS:</td><td>${v(d.columnas)} cm</td>
      <td>MALLAS:</td><td>${v(d.mallas)} cm</td>
      <td>ID DEL TEROHIGROMETRO:</td><td>${v(d.termo)}</td>
    </tr>
  </table>
  <table style="margin-top:2px">
    <tr>
      <td rowspan="2" style="padding:0;vertical-align:top">${dataNested}</td>
      <td>REALIZÓ: ${v(d.realizo)}</td>
    </tr>
    <tr><td>SUPERVISÓ: ${v(d.superviso)}</td></tr>
    <tr><td colspan="2" style="text-align:justify">OBSERVACIONES: ${v(d.observaciones)}</td></tr>
  </table>
  </div>`
}

// MET-7.2-11 — 2 cols: FECHA row, RESULTADO+REALIZÓ row, empty+SUPERVISÓ row, OBSERVACIONES
function bit711(d: any): string {
  return `<div class="seccion no-break">
  <table style="margin-top:2px"><tr><td>NÚMERO DE SOLICITUD: ${v(d.numeroSolicitud)}</td></tr></table>
  <table><tr><td class="titulo-prueba">TIPO DE TEJIDO MET-7.2-11</td></tr></table>
  <table style="margin-top:2px">
    <tr><td>FECHA:</td><td>${v(d.fecha)}</td></tr>
    <tr><td rowspan="2">RESULTADO: ${v(d.resultado)}</td><td>REALIZÓ: ${v(d.realizo)}</td></tr>
    <tr><td>SUPERVISÓ: ${v(d.superviso)}</td></tr>
    <tr><td colspan="2" style="text-align:justify">OBSERVACIONES: ${v(d.observaciones)}</td></tr>
  </table>
  </div>`
}

// MET-7.2-12 — Bitácora: header (número solicitud + título) + tabla 2 cols
function bit712(d: any): string {
  return `<div class="seccion no-break">
  <table style="margin-top:2px"><tr><td>NÚMERO DE SOLICITUD: ${v(d.numero_solicitud || d.numeroSolicitud)}</td></tr></table>
  <table><tr><td class="titulo-prueba">DETERMINACIÓN DEL TIPO DE LIGAMENTO MET-7.2-12</td></tr></table>
  <table style="margin-top:2px">
    <tr><td>FECHA:</td><td>${v(d.fecha)}</td></tr>
    <tr><td colspan="2">${v(d.tipo_tejido)}</td></tr>
    ${d.imagen_url ? `<tr><td colspan="2" class="center"><img src="${v(d.imagen_url)}" style="max-height:150px;max-width:100%;margin:4px 0"></td></tr>` : '<tr><td colspan="2">&nbsp;</td></tr>'}
    <tr><td colspan="2">RESULTADO: ${v(d.res_plano_lig)} ${v(d.res_punto_lig)}</td></tr>
    <tr><td colspan="2" style="text-align:justify">OBSERVACIONES: ${v(d.observaciones)}</td></tr>
    <tr><td>REALIZÓ: ${v(d.realizo)}</td><td>SUPERVISÓ: ${v(d.superviso)}</td></tr>
  </table>
  </div>`
}

// MET-7.2-19 — header (solicitud + título) + tabla 2 cols con RESULTADO inline REALIZÓ/SUPERVISÓ
function bit719(d: any): string {
  return `<div class="seccion no-break">
  <table style="margin-top:2px"><tr><td>NÚMERO DE SOLICITUD: ${v(d.numero_solicitud || d.numeroSolicitud)}</td></tr></table>
  <table><tr><td class="titulo-prueba">DETERMINACIÓN DEL TIPO DE ACABADO MET-7.2-19</td></tr></table>
  <table style="margin-top:2px">
    <tr><td>FECHA:</td><td>${v(d.fecha)}</td></tr>
    <tr><td rowspan="2">RESULTADO: ${v(d.resultado)}</td><td>REALIZÓ: ${v(d.realizo)}</td></tr>
    <tr><td>SUPERVISÓ: ${v(d.superviso)}</td></tr>
    <tr><td colspan="2" style="text-align:justify">OBSERVACIONES: ${v(d.observaciones)}</td></tr>
  </table>
  </div>`
}

// NMX-A-275 — Tabla 2: 12 cols, Tabla 3: 4 cols
function bit275(d: any): string {
  return `<div class="seccion no-break">
  <table><tr><td>NÚMERO DE SOLICITUD: ${v(d.numero_solicitud)}</td><td class="bold" style="text-align:right">MET 7.2-15</td></tr></table>
  <table><tr><td class="titulo-prueba">NMX-A-275/5-INNTEX-2000 DENSIDAD LINEAL DE HILOS EXTRAÍDOS DE LA TELA (MÉTODO A)</td></tr></table>
  <table style="margin-top:2px">
    <tr>
      <td>FECHA:</td><td>${v(d.fecha)}</td><td>HORA:</td><td>${v(d.hora)}</td>
      <td>° C:</td><td>${v(d.grados)}</td><td>% HR:</td><td>${v(d.hr)}</td>
      <td>SE ELIMINA LA MATERIA NO FIBROSA</td><td>${v(d.mat_no_fibrosa)}</td>
      <td>ID DEL TERMOHIGROMETRO</td><td>${v(d.termo)}</td>
    </tr>
  </table>
  <table style="margin-top:2px">
    <tr><td></td><td class="center bold">URDIMBRE</td><td class="center bold">TRAMA</td><td rowspan="3" style="vertical-align:middle">REALIZÓ: ${v(d.realizo)}</td></tr>
    <tr><td>HILOS TOTALES</td><td class="center">${v(d.hilos_ur)}</td><td class="center">${v(d.hilos_tr)}</td></tr>
    <tr><td>LONGITUD TOTAL (M)</td><td class="center">${v(d.longitud_ur)}</td><td class="center">${v(d.longitud_tr)}</td></tr>
    <tr><td>GRAMOS TOTALES (G)</td><td class="center">${v(d.gramos_ur)}</td><td class="center">${v(d.gramos_tr)}</td><td rowspan="3" style="vertical-align:middle">SUPERVISÓ: ${v(d.superviso)}</td></tr>
    <tr><td>NO. TEX.</td><td class="center"><b>${v(d.no_tex_ur)}</b></td><td class="center"><b>${v(d.no_tex_tr)}</b></td></tr>
    <tr><td>OTRO</td><td class="center">${v(d.otro_ur)}</td><td class="center">${v(d.otro_tr)}</td></tr>
    <tr><td colspan="4" style="text-align:justify">OBSERVACIONES: ${v(d.observaciones)}</td></tr>
  </table>
  </div>`
}

// NMX-A-172 — params 10 cols, 3 nested data tables inline, then OBSERVACIONES/REALIZÓ below
function bit172(d: any): string {
  const hiloNested = `<table style="width:100%;border-collapse:collapse">
    <tr><td colspan="2" class="center bold">ROTURA DEL HILO</td></tr>
    <tr><td class="bold">NO.</td><td class="center bold">CICLOS</td></tr>
    <tr><td>1</td><td class="center">${v(d.hilo1)}</td></tr>
    <tr><td>2</td><td class="center">${v(d.hilo2)}</td></tr>
    <tr><td>3</td><td class="center">${v(d.hilo3)}</td></tr>
    <tr><td>4</td><td class="center">${v(d.hilo4)}</td></tr>
    <tr><td>5</td><td class="center">${v(d.hilo5)}</td></tr>
    <tr><td class="bold">RESULTADO</td><td class="center"><b>${v(d.resultado1)}</b></td></tr>
  </table>`
  const colorNested = `<table style="width:100%;border-collapse:collapse">
    <tr><td colspan="2" class="center bold">CAMBIO DE COLOR</td></tr>
    <tr><td class="bold">NO.</td><td class="center bold">RESULTADO</td></tr>
    <tr><td>1</td><td class="center">${v(d.color1)}</td></tr>
    <tr><td>2</td><td class="center">${v(d.color2)}</td></tr>
    <tr><td>3</td><td class="center">${v(d.color3)}</td></tr>
    <tr><td>4</td><td class="center">${v(d.color4)}</td></tr>
    <tr><td>5</td><td class="center">${v(d.color5)}</td></tr>
    <tr><td class="bold">RESULTADO</td><td class="center"><b>${v(d.resultado2)}</b></td></tr>
  </table>`
  const frisaNested = `<table style="width:100%;border-collapse:collapse">
    <tr><td colspan="2" class="center bold">FRISAS</td></tr>
    <tr><td class="bold">NO.</td><td class="center bold">RESULTADO</td></tr>
    <tr><td>1</td><td class="center">${v(d.frisa1)}</td></tr>
    <tr><td>2</td><td class="center">${v(d.frisa2)}</td></tr>
    <tr><td>3</td><td class="center">${v(d.frisa3)}</td></tr>
    <tr><td>4</td><td class="center">${v(d.frisa4)}</td></tr>
    <tr><td>5</td><td class="center">${v(d.frisa5)}</td></tr>
    <tr><td class="bold">RESULTADO</td><td class="center"><b>${v(d.resultado3)}</b></td></tr>
  </table>`
  return `<div class="seccion no-break">
  <table><tr><td>NÚMERO DE SOLICITUD: ${v(d.numero_solicitud)}</td><td class="bold" style="text-align:right">MET 7.2-14</td></tr></table>
  <table><tr><td class="titulo-prueba">NMX-A-172-INNTEX-2012 RESISTENCIA A LA ABRASIÓN PLANA TABER</td></tr></table>
  <table style="margin-top:2px">
    <tr>
      <td>FECHA:</td><td>${v(d.fecha)}</td><td>HORA:</td><td>${v(d.hora)}</td>
      <td>° C:</td><td>${v(d.grados)}</td><td>% HR:</td><td>${v(d.hr)}</td>
      <td>CARGA (g):</td><td>${v(d.carga)}</td>
    </tr>
    <tr>
      <td>NIVEL DE VACÍO DE SUCCIÓN:</td><td>${v(d.nivel_vacio)}</td>
      <td>RUEDA ABRASIVA:</td><td>${v(d.rueda_abrasiva)}</td>
      <td>ID DEL TERMOHIGROMETRO:</td><td>${v(d.termo)}</td>
      <td>ALTURA DE LA BOQUILLA 7 + 1 mm</td><td>${v(d.alt_boquilla)}</td>
    </tr>
  </table>
  <table style="margin-top:2px">
    <tr>
      <td style="padding:0;vertical-align:top">${hiloNested}</td>
      <td style="padding:0;vertical-align:top">${colorNested}</td>
      <td style="padding:0;vertical-align:top">${frisaNested}</td>
    </tr>
    <tr>
      <td colspan="3">
        <table style="width:100%;border-collapse:collapse">
          <tr><td colspan="2" style="text-align:justify">OBSERVACIONES: ${v(d.observaciones)}</td></tr>
          <tr><td>REALIZÓ: ${v(d.realizo)}</td><td>SUPERVISÓ: ${v(d.superviso)}</td></tr>
        </table>
      </td>
    </tr>
  </table>
  </div>`
}

// NMX-A-9073 — params 10 cols, nested data table + REALIZÓ/SUPERVISÓ inline, OBSERVACIONES below
function bit9073(d: any): string {
  const dataNested = `<table style="width:100%;border-collapse:collapse">
    <tr><td class="bold">NO.</td><td class="center bold">GRAMOS</td><td class="center bold">RESULTADO</td></tr>
    <tr><td>1</td><td class="center">${v(d.no1_1)}</td><td class="center">${v(d.no1_2)}</td></tr>
    <tr><td>2</td><td class="center">${v(d.no2_1)}</td><td class="center">${v(d.no2_2)}</td></tr>
    <tr><td>3</td><td class="center">${v(d.no3_1)}</td><td class="center">${v(d.no3_2)}</td></tr>
    <tr><td>4</td><td class="center">${v(d.no4_1)}</td><td class="center">${v(d.no4_2)}</td></tr>
    <tr><td>5</td><td class="center">${v(d.no5_1)}</td><td class="center">${v(d.no5_2)}</td></tr>
    <tr><td class="bold">PROMEDIO</td><td colspan="2" class="center"><b>${v(d.promedio)} g/m²</b></td></tr>
  </table>`
  return `<div class="seccion no-break">
  <table style="margin-top:2px"><tr><td>NUMERO DE SOLICITUD: ${v(d.numero_solicitud || d.numeroSolicitud)}</td></tr></table>
  <table><tr><td class="titulo-prueba">NMX-A-9073/1-INNTEX-2018 DETERMINACIÓN DE LA MASA POR UNIDAD DE ÁREA</td><td class="right">MET-7.2-9</td></tr></table>
  <table style="margin-top:2px">
    <tr>
      <td>FECHA:</td><td>${v(d.fecha)}</td><td>HORA:</td><td>${v(d.hora)}</td>
      <td>° C:</td><td>${v(d.grados)}</td><td>% HR:</td><td>${v(d.hr)}</td>
      <td>ID DEL TERMOHIGROMETRO:</td><td>${v(d.termo)}</td>
    </tr>
  </table>
  <table style="margin-top:2px">
    <tr>
      <td rowspan="2" style="padding:0;vertical-align:top">${dataNested}</td>
      <td>REALIZÓ: ${v(d.realizo)}</td>
    </tr>
    <tr><td>SUPERVISÓ: ${v(d.superviso)}</td></tr>
    <tr><td colspan="2" style="text-align:justify">OBSERVACIONES: ${v(d.observaciones)}</td></tr>
  </table>
  </div>`
}

// NMX-A-4920 — params 8 cols (row2: 4 cols), nested data table + REALIZÓ/SUPERVISÓ inline, OBSERVACIONES below
function bit4920(d: any): string {
  const dataNested = `<table style="width:100%;border-collapse:collapse">
    <tr><td class="bold">NO.</td><td class="center bold">GRADO DE HUMEDECIMIENTO</td></tr>
    <tr><td>1</td><td class="center">${v(d.humed1)}</td></tr>
    <tr><td>2</td><td class="center">${v(d.humed2)}</td></tr>
    <tr><td>3</td><td class="center">${v(d.humed3)}</td></tr>
  </table>`
  return `<div class="seccion no-break">
  <table style="margin-top:2px">
    <tr>
      <td>NÚMERO DE SOLICITUD: ${v(d.numero_solicitud)}</td>
      <td class="right">MET 7.2-17</td>
    </tr>
  </table>
  <table><tr><td class="titulo-prueba">NMX-A-4920-INNTEX-2017 DETERMINACIÓN DE LA RESISTENCIA AL HUMEDECIMIENTO SUPERFICIAL (MÉTODO DE ROCÍO)</td></tr></table>
  <table style="margin-top:2px">
    <tr>
      <td>FECHA:</td><td>${v(d.fecha)}</td><td>HORA:</td><td>${v(d.hora)}</td>
      <td>° C:</td><td>${v(d.grados)}</td><td>% HR:</td><td>${v(d.hr)}</td>
    </tr>
    <tr>
      <td colspan="2">TEMPERATURA DEL AGUA: </td><td colspan="3">${v(d.temp_agua)}</td>
      <td colspan="2">ID DEL TERMOHIROMETRO:</td><td>${v(d.termo)}</td>
    </tr>
  </table>
  <table style="margin-top:2px">
    <tr>
      <td rowspan="2" style="padding:0;vertical-align:top">${dataNested}</td>
      <td>REALIZÓ: ${v(d.realizo)}</td>
    </tr>
    <tr><td>SUPERVISÓ: ${v(d.superviso)}</td></tr>
    <tr><td colspan="2" style="text-align:justify">OBSERVACIONES: ${v(d.observaciones)}</td></tr>
  </table>
  </div>`
}

// NMX-A-12945 — params 12 cols, 2 data tables (13 cols each, no colspans), REALIZÓ/SUPERVISÓ below
function bit12945(d: any): string {
  function fila(tiempo: string, f1: string, f2: string, f3: string, pf: string, v1: string, v2: string, v3: string, pv: string, e1: string, e2: string, e3: string, pe: string) {
    return `<tr>
      <td>${tiempo}</td>
      <td>${f1}</td><td>${f2}</td><td>${f3}</td><td>${pf}</td>
      <td>${v1}</td><td>${v2}</td><td>${v3}</td><td>${pv}</td>
      <td>${e1}</td><td>${e2}</td><td>${e3}</td><td>${pe}</td>
    </tr>`
  }
  return `<div class="seccion no-break">
  <table><tr><td>NUMERO DE SOLICITUD: ${v(d.numero_solicitud)}</td><td class="bold" style="text-align:right">MET-7.2-16</td></tr></table>
  <table><tr><td class="titulo-prueba">NMX-A-12945-3-INNTEX-2020 DETERMINACIÓN DE LA PROPENSIÓN DE LA SUPERFICIE DE LA TELA AL FRISADO, VELLOSIDAD O ENMARAÑAMIENTO</td></tr></table>
  <table style="margin-top:2px">
    <tr>
      <td>FECHA:</td><td>${v(d.fecha)}</td><td>HORA:</td><td>${v(d.hora)}</td>
      <td>° C:</td><td>${v(d.grados)}</td><td>% HR:</td><td>${v(d.hr)}</td>
      <td>LAVADO:</td><td>${v(d.lavado)}</td><td>SECADO:</td><td>${v(d.secado)}</td>
    </tr>
    <tr>
      <td>TIEMPO DE ENSAYO:</td><td colspan="3">${v(d.tiempo_ensayo)}</td>
      <td>TIPO DE REVESTIMIENTO:</td><td colspan="3">${v(d.tipo_revestimiento)}</td>
      <td colspan="2">PATRONES DE CLASIF. FOTOGRÁFICA</td><td colspan="2">${v(d.patrones)}</td>
    </tr>
    <tr>
      <td>DISPOSITIVO:</td><td>${v(d.dispositivo)}</td>
      <td colspan="2">NO. DE OBSERVADORES:</td><td>${v(d.no_observadores)}</td>
      <td colspan="2">FORMA DE LOS ESPECÍMENES:</td><td>${v(d.forma_espec)}</td>
      <td colspan="2">ID DEL TERMOHIGROMETRO:</td><td colspan="2">${v(d.termo)}</td>
    </tr>
  </table>
  <table style="margin-top:2px">
    <tr><td colspan="13">PRIMER CICLO</td></tr>
    <tr><td class="bold">TIEMPO</td><td class="center bold" colspan="4">FRISAS</td><td class="center bold" colspan="4">VELLOSIDAD</td><td class="center bold" colspan="4">ENMARAÑAMIENTO</td></tr>
    <tr><td class="bold">NO. DE ESPÉCIMEN</td><td class="center bold">1</td><td class="center bold">2</td><td class="center bold">3</td><td class="center bold">PROMEDIO</td><td class="center bold">1</td><td class="center bold">2</td><td class="center bold">3</td><td class="center bold">PROMEDIO</td><td class="center bold">1</td><td class="center bold">2</td><td class="center bold">3</td><td class="center bold">PROMEDIO</td></tr>
    ${fila('5 MINS',v(d['1frisas1_5']),v(d['2frisas1_5']),v(d['3frisas1_5']),v(d.prom_frisas5),v(d['1vellosidad1_5']),v(d['2vellosidad1_5']),v(d['3vellosidad1_5']),v(d.prom_vellosidad5),v(d['1enmaranamiento1_5']),v(d['2enmaranamiento1_5']),v(d['3enmaranamiento1_5']),v(d.prom_enmara5))}
    ${fila('15 MINS',v(d['1frisas1_15']),v(d['2frisas1_15']),v(d['3frisas1_15']),v(d.prom_frisas15),v(d['1vellosidad1_15']),v(d['2vellosidad1_15']),v(d['3vellosidad1_15']),v(d.prom_vellosidad15),v(d['1enmaranamiento1_15']),v(d['2enmaranamiento1_15']),v(d['3enmaranamiento1_15']),v(d.prom_enmara15))}
    ${fila('30 MINS',v(d['1frisas1_30']),v(d['2frisas1_30']),v(d['3frisas1_30']),v(d.prom_frisas30),v(d['1vellosidad1_30']),v(d['2vellosidad1_30']),v(d['3vellosidad1_30']),v(d.prom_vellosidad30),v(d['1enmaranamiento1_30']),v(d['2enmaranamiento1_30']),v(d['3enmaranamiento1_30']),v(d.prom_enmara30))}
  </table>
  <table style="margin-top:2px">
    <tr><td colspan="13">SEGUNDO CICLO</td></tr>
    <tr><td class="bold">TIEMPO</td><td class="center bold" colspan="4">FRISAS</td><td class="center bold" colspan="4">VELLOSIDAD</td><td class="center bold" colspan="4">ENMARAÑAMIENTO</td></tr>
    <tr><td class="bold">NO. DE ESPÉCIMEN</td><td class="center bold">1</td><td class="center bold">2</td><td class="center bold">3</td><td class="center bold">PROMEDIO</td><td class="center bold">1</td><td class="center bold">2</td><td class="center bold">3</td><td class="center bold">PROMEDIO</td><td class="center bold">1</td><td class="center bold">2</td><td class="center bold">3</td><td class="center bold">PROMEDIO</td></tr>
    ${fila('5 MINS',v(d['1frisas2_5']),v(d['2frisas2_5']),v(d['3frisas2_5']),v(d.prom_frisas5_2),v(d['1vellosidad2_5']),v(d['2vellosidad2_5']),v(d['3vellosidad2_5']),v(d.prom_vellosidad5_2),v(d['1enmaranamiento2_5']),v(d['2enmaranamiento2_5']),v(d['3enmaranamiento2_5']),v(d.prom_enmara5_2))}
    ${fila('15 MINS',v(d['1frisas2_15']),v(d['2frisas2_15']),v(d['3frisas2_15']),v(d.prom_frisas15_2),v(d['1vellosidad2_15']),v(d['2vellosidad2_15']),v(d['3vellosidad2_15']),v(d.prom_vellosidad15_2),v(d['1enmaranamiento2_15']),v(d['2enmaranamiento2_15']),v(d['3enmaranamiento2_15']),v(d.prom_enmara15_2))}
    ${fila('30 MINS',v(d['1frisas2_30']),v(d['2frisas2_30']),v(d['3frisas2_30']),v(d.prom_frisas30_2),v(d['1vellosidad2_30']),v(d['2vellosidad2_30']),v(d['3vellosidad2_30']),v(d.prom_vellosidad30_2),v(d['1enmaranamiento2_30']),v(d['2enmaranamiento2_30']),v(d['3enmaranamiento2_30']),v(d.prom_enmara30_2))}
  </table>
  <table style="margin-top:2px">
    <tr><td colspan="2" style="text-align:justify">OBSERVACIONES: ${v(d.observaciones)}</td></tr>
    <tr><td>REALIZÓ: ${v(d.realizo)}</td><td>SUPERVISÓ: ${v(d.superviso)}</td></tr>
  </table>
  </div>`
}

// NMX-A-083 — generado desde datos estructurados
function bit083(d: any): string {
  const encabezado = `<table><tr><td class="titulo-prueba">NMX-A-083-INNTEX-2020 EVALUACIÓN DE CONFECCIÓN Y DIMENSIÓN DE PRENDAS</td></tr></table>
    <table>
      <tr>
        <td class="bold" colspan="3">FRPF-7.2-3</td>
        <td class="bold" colspan="3">REV. 1</td>
      </tr>
      <tr>
        <td class="bold" style="width:16%">NO. DE SOLICITUD:</td><td style="width:17%;text-align:center">${v(d.numero_solicitud)}</td>
        <td class="bold" style="width:16%">FECHA:</td><td style="width:17%;text-align:center">${v(d.fecha)}</td>
        <td class="bold" style="width:16%">HORA:</td><td style="width:18%;text-align:center">${v(d.hora)}</td>
      </tr>
      <tr>
        <td class="bold">°C:</td><td style="text-align:center">${v(d.temperatura)}</td>
        <td class="bold">%HR:</td><td style="text-align:center">${v(d.humedad)}</td>
        <td class="bold">ID TERMOHIGRÓMETRO:</td><td style="text-align:center">${v(d.id_termohigrometro)}</td>
      </tr>
      <tr>
        <td class="bold" colspan="2">ESPECIFICACIÓN DEL CLIENTE:</td>
        <td colspan="4" style="text-align:justify">${v(d.especificacion)}</td>
      </tr>
      <tr>
        <td class="bold">PRENDA:</td><td colspan="5" style="text-align:justify">${v(d.prenda)}</td>
      </tr>
      <tr>
        <td class="bold">REALIZÓ:</td><td colspan="2" style="text-align:center">${v(d.realizo)}</td>
        <td class="bold">SUPERVISÓ:</td><td colspan="2" style="text-align:center">${v(d.superviso)}</td>
      </tr>
    </table>`

  const conf = (val: string) => {
    if (val === 'cumple') return '<span class="bit083-cumple">CUMPLE</span>'
    if (val === 'no_cumple') return '<span class="bit083-no-cumple">NO CUMPLE</span>'
    return '—'
  }

  const ORDEN_SECCIONES_083 = ['descripcion', 'dimensiones', 'corte_confeccion', 'terminado', 'tipo_puntadas', 'tipos_hilos', 'etiquetado']
  const tieneContenido083 = (key: string): boolean => {
    switch (key) {
      case 'descripcion':      return Array.isArray(d.descripcion_tabla) && d.descripcion_tabla.length > 0
      case 'dimensiones':      return Array.isArray(d.dimensiones) && d.dimensiones.length > 0
      case 'corte_confeccion': return Array.isArray(d.confeccion) && d.confeccion.length > 0
      case 'terminado':        return Array.isArray(d.terminado) && d.terminado.length > 0
      case 'tipo_puntadas':    return Array.isArray(d.tipo_puntadas) && d.tipo_puntadas.length > 0
      case 'tipos_hilos':      return Array.isArray(d.tipos_hilos) && d.tipos_hilos.length > 0
      case 'etiquetado':       return Array.isArray(d.etiquetado) && d.etiquetado.length > 0
      default: return false
    }
  }
  const seccionesActivas = ORDEN_SECCIONES_083.filter(key => tieneContenido083(key))

  const norma = v(d.norma)
  const tituloStyle = 'font-weight:bold;text-align:center;background:#e8e8e8;padding:4px'
  const thStyle = 'font-weight:bold;text-align:center;padding:3px;white-space:nowrap'
  const notaDiv = (nota: string | null | undefined) =>
    nota ? `<div style="margin:4px 0 8px 0;padding:4px 6px;font-size:9pt;break-inside:avoid;page-break-inside:avoid">${nota}</div>` : ''

  const tabla3col = (titulo: string, headerLeft: string, rows: { criteria: string; conformidad: string; comentario?: string; mostrar_comentario?: boolean }[]) => {
    const filas = rows.length === 0
      ? `<tr><td colspan="2" class="center">Sin datos</td></tr>`
      : rows.map(r => `<tr>
          <td style="padding:3px 4px;text-align:justify">${r.criteria}</td>
          <td style="text-align:center;padding:3px">${conf(r.conformidad)}</td>
        </tr>${r.comentario && r.mostrar_comentario ? `<tr><td colspan="2" style="font-style:italic;font-size:7.5pt;background:#f9f9f9;text-align:justify"><strong style="font-style:normal">Observación:</strong> ${v(r.comentario)}</td></tr>` : ''}`).join('')
    return `<table style="margin-top:4px">
      <tr><td colspan="2" style="${tituloStyle}">${titulo}</td></tr>
      <tr>
        <td style="font-weight:bold;padding:3px 4px;text-align:center">${headerLeft}</td>
        <td style="${thStyle}">CONFORMIDAD</td>
      </tr>
      ${filas}
    </table>`
  }

  const tablaDescripcion = () => {
    const rows = (Array.isArray(d.descripcion_tabla) ? d.descripcion_tabla : [])
      .filter((r: any) => v(r.punto_medicion))
      .map((r: any) => ({ criteria: v(r.punto_medicion), conformidad: r.conformidad || '', comentario: r.comentario, mostrar_comentario: r.mostrar_comentario }))
    return tabla3col(v(d.titulo_descripcion) || 'DESCRIPCION', 'DESCRIPCIÓN DE LA CONFECCIÓN', rows)
  }

  const tablaDimensiones = () => {
    const rows: any[] = (Array.isArray(d.dimensiones) ? d.dimensiones : []).filter((r: any) => v(r.punto_medicion))
    const titulo = v(d.titulo_dimensiones) || 'DIMENSIONES'
    const tieneExtra = rows.some((r: any) => v(r.medicion) || v(r.especificacion))
    const cols = tieneExtra ? 4 : 2
    const extraHeaders = tieneExtra
      ? `<td style="${thStyle}">MEDICIÓN (cm)</td><td style="${thStyle}">ESPECIFICACIÓN (cm)</td>`
      : ''
    const filas = rows.length === 0
      ? `<tr><td colspan="${cols}" class="center">Sin datos</td></tr>`
      : rows.map((r: any) => {
          const nota = r.comentario && r.mostrar_comentario
            ? `<tr><td colspan="${cols}" style="font-style:italic;font-size:7.5pt;background:#f9f9f9;text-align:justify"><strong style="font-style:normal">Observación:</strong> ${v(r.comentario)}</td></tr>`
            : ''
          const confVal = v(r.especificacion).toLowerCase() === 'no aplica' ? '—' : conf(r.conformidad)
          if (tieneExtra)
            return `<tr><td style="padding:3px 4px;text-align:justify">${v(r.punto_medicion)}</td><td style="text-align:center;padding:3px">${v(r.medicion)}</td><td style="text-align:center;padding:3px">${v(r.especificacion)}</td><td style="text-align:center;padding:3px">${confVal}</td></tr>${nota}`
          return `<tr><td style="padding:3px 4px;text-align:justify">${v(r.punto_medicion)}</td><td style="text-align:center;padding:3px">${confVal}</td></tr>${nota}`
        }).join('')
    return `<table style="margin-top:4px">
      <tr><td colspan="${cols}" style="${tituloStyle}">${titulo}</td></tr>
      <tr>
        <td style="font-weight:bold;padding:3px 4px;text-align:center">PUNTO DE MEDICIÓN</td>
        ${extraHeaders}
        <td style="${thStyle}">CONFORMIDAD</td>
      </tr>
      ${filas}
    </table>`
  }

  const tablaCorteConfeccion = () => {
    const rows: any[] = (Array.isArray(d.confeccion) ? d.confeccion : []).filter((r: any) => v(r.evaluacion))
    const tieneExtra = rows.some((r: any) => v(r.medicion) || v(r.especificacion))
    const cols = tieneExtra ? 4 : 2
    const extraHeaders = tieneExtra
      ? `<td style="${thStyle}">MEDICIÓN</td><td style="${thStyle}">ESPECIFICACIÓN</td>`
      : ''
    const filas = rows.length === 0
      ? `<tr><td colspan="${cols}" class="center">Sin datos</td></tr>`
      : rows.map((r: any) => {
          const nota = r.comentario && r.mostrar_comentario
            ? `<tr><td colspan="${cols}" style="font-style:italic;font-size:7.5pt;background:#f9f9f9;text-align:justify"><strong style="font-style:normal">Observación:</strong> ${v(r.comentario)}</td></tr>`
            : ''
          const confVal = v(r.especificacion).toLowerCase() === 'no aplica' ? '—' : conf(r.conformidad)
          if (tieneExtra && !v(r.medicion) && !v(r.especificacion))
            return `<tr><td colspan="3" style="padding:3px 4px;text-align:justify">${v(r.evaluacion)}</td><td style="text-align:center;padding:3px">${confVal}</td></tr>${nota}`
          if (tieneExtra)
            return `<tr><td style="padding:3px 4px;text-align:justify">${v(r.evaluacion)}</td><td style="text-align:center;padding:3px">${v(r.medicion)}</td><td style="text-align:center;padding:3px">${v(r.especificacion)}</td><td style="text-align:center;padding:3px">${confVal}</td></tr>${nota}`
          return `<tr><td style="padding:3px 4px;text-align:justify">${v(r.evaluacion)}</td><td style="text-align:center;padding:3px">${confVal}</td></tr>${nota}`
        }).join('')
    return `<table style="margin-top:4px">
      <tr><td colspan="${cols}" style="${tituloStyle}">${v(d.titulo_confeccion) || 'CORTE Y CONFECCIÓN'}</td></tr>
      <tr>
        <td style="font-weight:bold;padding:3px 4px;text-align:center">EVALUACIÓN DE LA CONFECCIÓN</td>
        ${extraHeaders}
        <td style="${thStyle}">CONFORMIDAD</td>
      </tr>
      ${filas}
    </table>`
  }

  const tablaTipoPuntadas = () => {
    const rows = (Array.isArray(d.tipo_puntadas) ? d.tipo_puntadas : [])
      .filter((r: any) => v(r.descripcion))
      .map((r: any) => ({ criteria: v(r.descripcion), conformidad: r.conformidad || '', comentario: r.comentario, mostrar_comentario: r.mostrar_comentario }))
    return tabla3col(v(d.titulo_tipo_puntadas) || 'TIPO DE PUNTADAS', 'EVALUACIÓN DE LAS PUNTADAS', rows)
  }

  const tablaTiposHilos = () => {
    const rows: any[] = (Array.isArray(d.tipos_hilos) ? d.tipos_hilos : []).filter((r: any) => v(r.descripcion))
    const filas = rows.length === 0
      ? `<tr><td colspan="2" class="center">Sin datos</td></tr>`
      : rows.map((r: any) => {
          const nota = r.comentario && r.mostrar_comentario
            ? `<tr><td colspan="2" style="font-style:italic;font-size:7.5pt;background:#f9f9f9;text-align:justify"><strong style="font-style:normal">Observación:</strong> ${v(r.comentario)}</td></tr>`
            : ''
          return `<tr>
            <td style="padding:3px 4px;text-align:justify">${v(r.descripcion)}</td>
            <td style="text-align:center;padding:3px">${conf(r.conformidad)}</td>
          </tr>${nota}`
        }).join('')
    return `<table style="margin-top:4px">
      <tr><td colspan="2" style="${tituloStyle}">${v(d.titulo_tipos_hilos) || 'EVALUACIÓN DEL TIPO DE HILO DE COSTURA'}</td></tr>
      <tr>
        <td style="font-weight:bold;padding:3px 4px;text-align:center">CRITERIO</td>
        <td style="${thStyle}">CONFORMIDAD</td>
      </tr>
      ${filas}
    </table>`
  }

  const tablaTerminado = () => {
    const rows: any[] = (Array.isArray(d.terminado) ? d.terminado : []).filter((r: any) => v(r.descripcion))
    const filas = rows.length === 0
      ? `<tr><td colspan="2" class="center">Sin datos</td></tr>`
      : rows.map((r: any) => {
          const nota = r.comentario && r.mostrar_comentario
            ? `<tr><td colspan="2" style="font-style:italic;font-size:7.5pt;background:#f9f9f9;text-align:justify"><strong style="font-style:normal">Observación:</strong> ${v(r.comentario)}</td></tr>`
            : ''
          return `<tr>
            <td style="padding:3px 4px;text-align:justify">${v(r.descripcion)}</td>
            <td style="text-align:center;padding:3px">${conf(r.conformidad)}</td>
          </tr>${nota}`
        }).join('')
    return `<table style="margin-top:4px">
      <tr><td colspan="2" style="${tituloStyle}">${v(d.titulo_terminado) || 'EVALUACIÓN DEL TERMINADO DE LA PRENDA'}</td></tr>
      <tr>
        <td style="font-weight:bold;padding:3px 4px;text-align:center">CRITERIO</td>
        <td style="${thStyle}">CONFORMIDAD</td>
      </tr>
      ${filas}
    </table>`
  }

  const tablaEtiquetado = () => {
    const rows: any[] = (Array.isArray(d.etiquetado) ? d.etiquetado : []).filter((r: any) => v(r.descripcion))
    const filas = rows.length === 0
      ? `<tr><td colspan="2" class="center">Sin datos</td></tr>`
      : rows.map((r: any) => {
          const nota = r.comentario && r.mostrar_comentario
            ? `<tr><td colspan="2" style="font-style:italic;font-size:7.5pt;background:#f9f9f9;text-align:justify"><strong style="font-style:normal">Observación:</strong> ${v(r.comentario)}</td></tr>`
            : ''
          return `<tr>
            <td style="padding:3px 4px;text-align:justify">${v(r.descripcion)}</td>
            <td style="text-align:center;padding:3px">${conf(r.conformidad)}</td>
          </tr>${nota}`
        }).join('')
    return `<table style="margin-top:4px">
      <tr><td colspan="2" style="${tituloStyle}">${v(d.titulo_etiquetado) || 'NOM-004-SE-2021 Información comercial-Etiquetado de productos textiles, prendas de vestir, sus accesorios y ropa de casa — INSPECCIÓN DEL ETIQUETADO — PRUEBA NO ACREDITADA'}</td></tr>
      <tr>
        <td style="font-weight:bold;padding:3px 4px;text-align:center">CRITERIO</td>
        <td style="${thStyle}">CONFORMIDAD</td>
      </tr>
      ${filas}
    </table>`
  }

  const seccionesHtml = seccionesActivas.map(key => {
    switch (key) {
      case 'descripcion':      return tablaDescripcion() + notaDiv(d.nota_descripcion)
      case 'dimensiones':      return tablaDimensiones() + notaDiv(d.nota_dimensiones)
      case 'corte_confeccion': return tablaCorteConfeccion() + notaDiv(d.nota_confeccion)
      case 'tipo_puntadas':    return tablaTipoPuntadas() + notaDiv(d.nota_tipo_puntadas)
      case 'tipos_hilos':      return tablaTiposHilos() + notaDiv(d.nota_tipos_hilos)
      case 'terminado':        return tablaTerminado() + notaDiv(d.nota_terminado)
      case 'etiquetado':       return tablaEtiquetado() + notaDiv(d.nota_etiquetado)
      default: return ''
    }
  }).join('')

  const claveDiv = d.clave
    ? `<div style="margin:4px 0 8px;padding:4px 6px"><strong><em>CLAVE: ${escapeHtml(v(d.clave))}</em></strong></div>`
    : ''

  return `<div class="seccion">
    <div style="break-inside:avoid">
      ${encabezado}
      ${claveDiv}
      ${notaDiv(d.nota_doc)}
      ${notaDiv(d.nota_general)}
    </div>
    ${seccionesHtml}
  </div>`
}

// NMX-A-073 — Tabla 2: 4 cols, Tabla 3: 5 cols
function bit073(d: any): string {
  const datosFrote = `<table style="width:100%;border-collapse:collapse">
    <tr><td></td><td colspan="2" class="center bold">SECO</td><td colspan="2" class="center bold">HÚMEDO</td></tr>
    <tr><td></td><td class="center bold">GRADO DE TRANSFERENCIA</td><td class="center bold">GRADO DE CAMBIO DE COLOR</td><td class="center bold">GRADO DE TRANSFERENCIA</td><td class="center bold">GRADO DE CAMBIO DE COLOR</td></tr>
    <tr><td class="bold">URDIMBRE</td><td class="center">${v(d.seco_tu)}</td><td class="center">${v(d.seco_cu)}</td><td class="center">${v(d.humedo_tu)}</td><td class="center">${v(d.humedo_cu)}</td></tr>
    <tr><td class="bold">TRAMA</td><td class="center">${v(d.seco_tt)}</td><td class="center">${v(d.seco_ct)}</td><td class="center">${v(d.humedo_tt)}</td><td class="center">${v(d.humedo_ct)}</td></tr>
  </table>`
  return `<div class="seccion no-break">
  <table><tr><td class="titulo-prueba">NMX-A-073-INNTEX-2005 SOLIDEZ DEL COLOR AL FROTE</td></tr></table>
  <table style="margin-top:2px">
    <tr>
      <td>NO. DE SOLICITUD:</td><td>${v(d.numero_solicitud)}</td>
      <td>FECHA:</td><td>${v(d.fecha)}</td>
    </tr>
    <tr>
      <td>HORA: ${v(d.hora)}</td><td>°C: ${v(d.grados)}</td>
      <td>% HR: ${v(d.hr)}</td><td>ID DE TERMOHIGRÓMETRO: ${v(d.termo)}</td>
    </tr>
    <tr>
      <td colspan="3" rowspan="2" style="padding:0;vertical-align:top">${datosFrote}</td>
      <td>REALIZÓ: ${v(d.realizo)}</td>
    </tr>
    <tr><td>SUPERVISÓ: ${v(d.superviso)}</td></tr>
    <tr><td colspan="4" style="text-align:justify">OBSERVACIONES: ${v(d.observaciones)}</td></tr>
  </table>
  </div>`
}

// NMX-A-105-C06 — header 8 cols (params), then row4: nested DW + nested TV + REALIZÓ, row5: empty+empty+SUPERVISÓ, row6: OBSERVACIONES
function bit105(d: any): string {
  const labelDiacetato = v(d.diacetato_dw_label) || 'diacetato (acetato)'
  const labelTriacetato = v(d.diacetato_tv_label) || 'triacetato (acetato)'
  const dw = `<table style="width:100%;border-collapse:collapse">
    <tr><td colspan="2" class="center bold">TELA MULTIFIBRA DW</td></tr>
    <tr><td class="bold">FIBRA</td><td class="center bold">TRANSFERENCIA</td></tr>
    <tr><td>${labelDiacetato}</td><td class="center">${v(d.diacetato_dw)}</td></tr>
    <tr><td>ALGODÓN blanqueado</td><td class="center">${v(d.algodon_dw)}</td></tr>
    <tr><td>poliamida</td><td class="center">${v(d.poliamida_dw)}</td></tr>
    <tr><td>poliéster</td><td class="center">${v(d.poliester_dw)}</td></tr>
    <tr><td>acrílico</td><td class="center">${v(d.acrilico_dw)}</td></tr>
    <tr><td>lana</td><td class="center">${v(d.lana_dw)}</td></tr>
    <tr><td>CAMBIO DE COLOR</td><td class="center">${v(d.cambio_color_dw)}</td></tr>
  </table>`
  const tv = `<table style="width:100%;border-collapse:collapse">
    <tr><td colspan="2" class="center bold">TELA MULTIFIBRA TV</td></tr>
    <tr><td class="bold">FIBRA</td><td class="center bold">TRANSFERENCIA</td></tr>
    <tr><td>${labelTriacetato}</td><td class="center">${v(d.diacetato_tv)}</td></tr>
    <tr><td>ALGODÓN blanqueado</td><td class="center">${v(d.algodon_tv)}</td></tr>
    <tr><td>poliamida</td><td class="center">${v(d.poliamida_tv)}</td></tr>
    <tr><td>poliéster</td><td class="center">${v(d.poliester_tv)}</td></tr>
    <tr><td>acrílico</td><td class="center">${v(d.acrilico_tv)}</td></tr>
    <tr><td>viscosa</td><td class="center">${v(d.lana_tv)}</td></tr>
    <tr><td>CAMBIO DE COLOR</td><td class="center">${v(d.cambio_color_tv)}</td></tr>
  </table>`
  return `<div class="seccion no-break">
  <table><tr><td class="titulo-prueba">NMX-A-105-C06-INNTEX-2015 SOLIDEZ DEL COLOR AL LAVADO DOMÉSTICO E INDUSTRIAL</td></tr></table>
  <table style="margin-top:2px">
    <tr>
      <td>NO. DE SOLICITUD:</td><td colspan="3">${v(d.numero_solicitud)}</td>
      <td>FECHA:</td><td colspan="3">${v(d.fecha)}</td>
    </tr>
    <tr>
      <td>MÉTODO:</td><td>${v(d.metodo_c)}</td>
      <td>CLORO DISPONIBLE:</td><td>${v(d.cloro_c)}</td>
      <td>TIEMPO:</td><td>${v(d.tiempo_c)}</td>
      <td>TEMP. DE SECADO:</td><td>${v(d.temp_secado_c)}</td>
    </tr>
    <tr>
      <td>VOL. BAÑO:</td><td>${v(d.vol_bano_c)}</td>
      <td>TEMPERATURA:</td><td>${v(d.temp_c)}</td>
      <td>BALINES:</td><td>${v(d.balines_c)}</td>
      <td>AJUSTE pH:</td><td>${v(d.ajuste_ph_c)}</td>
    </tr>
    <tr>
      <td>TIPO DE SECADO:</td><td colspan="3">${v(d.secado_c)}</td>
      <td>DETERGENTE:</td><td colspan="3">${v(d.detergente_c)}</td>
    </tr>
    <tr>
      <td colspan="3" style="padding:0;vertical-align:top">${dw}</td>
      <td colspan="3" style="padding:0;vertical-align:top">${tv}</td>
      <td colspan="2">REALIZÓ: ${v(d.realizo)}</td>
    </tr>
    <tr>
      <td colspan="6"></td>
      <td colspan="2">SUPERVISÓ: ${v(d.superviso)}</td>
    </tr>
    <tr><td colspan="8" style="text-align:justify">OBSERVACIONES: ${v(d.observaciones)}</td></tr>
  </table>
  </div>`
}

// NMX-A-105-E04 (SUDOR) — 4 cols, ÁCIDO/ALCALINO inline con SUPERVISÓ
function bit104(d: any): string {
  const labelDiacetatoAc = v(d.diacetato_acido_label) || 'diacetato (acetato)'
  const labelDiacetatoAl = v(d.diacetato_alcalino_label) || 'diacetato (acetato)'
  const datosAcAl = `<table style="width:100%;border-collapse:collapse">
    <tr><td colspan="2" class="center bold">ÁCIDO</td><td colspan="2" class="center bold">ALCALINO</td></tr>
    <tr><td class="center bold">FIBRA</td><td class="center bold">TRANSFERENCIA</td><td class="center bold">FIBRA</td><td class="center bold">TRANSFERENCIA</td></tr>
    <tr><td>${labelDiacetatoAc}</td><td class="center">${v(d.diacetato_ac)}</td><td>${labelDiacetatoAl}</td><td class="center">${v(d.diacetato_al)}</td></tr>
    <tr><td>ALGODÓN blanqueado</td><td class="center">${v(d.algodon_ac)}</td><td>ALGODÓN blanqueado</td><td class="center">${v(d.algodon_al)}</td></tr>
    <tr><td>poliamida</td><td class="center">${v(d.poliamida_ac)}</td><td>poliamida</td><td class="center">${v(d.poliamida_al)}</td></tr>
    <tr><td>poliéster</td><td class="center">${v(d.poliester_ac)}</td><td>poliéster</td><td class="center">${v(d.poliester_al)}</td></tr>
    <tr><td>acrílico</td><td class="center">${v(d.acrilico_ac)}</td><td>acrílico</td><td class="center">${v(d.acrilico_al)}</td></tr>
    <tr><td>lana</td><td class="center">${v(d.lana_ac)}</td><td>lana</td><td class="center">${v(d.lana_al)}</td></tr>
    <tr><td>CAMBIO DE COLOR</td><td class="center">${v(d.cambio_color_ac)}</td><td>CAMBIO DE COLOR</td><td class="center">${v(d.cambio_color_al)}</td></tr>
  </table>`
  return `<div class="seccion no-break">
  <table><tr><td class="titulo-prueba">NMX-A-105-E04-INNTEX-2019 SOLIDEZ DEL COLOR AL SUDOR</td></tr></table>
  <table style="margin-top:2px">
    <tr>
      <td>NO. DE SOLICITUD:</td><td>${v(d.numero_solicitud)}</td>
      <td>FECHA:</td><td>${v(d.fecha)}</td>
    </tr>
    <tr>
      <td colspan="3">POSICIÓN DE LOS ESPECÍMENES: ${v(d.pos_especimenes)}</td>
      <td>REALIZÓ: ${v(d.realizo)}</td>
    </tr>
    <tr>
      <td colspan="3" style="padding:0;vertical-align:top">${datosAcAl}</td>
      <td>SUPERVISÓ: ${v(d.superviso)}</td>
    </tr>
    <tr><td colspan="4" style="text-align:justify">OBSERVACIONES: ${v(d.observaciones)}</td></tr>
  </table>
  </div>`
}

// NMX-A-5077 — params 12 cols, 2 nested data tables side-by-side, then promedio/redondeo/observaciones
function bit5077(d: any): string {
  function muestraNested(label: string, prefix: string) {
    return `<table style="width:100%;border-collapse:collapse">
      <tr><td colspan="8" class="center bold">${label}</td></tr>
      <tr><td colspan="4" class="center bold">Urdimbre/ Columnas</td><td colspan="4" class="center bold">Trama / Mallas</td></tr>
      <tr><td colspan="2" class="center bold">Medición inicial</td><td colspan="2" class="center bold">Medición final</td><td colspan="2" class="center bold">Medición inicial</td><td colspan="2" class="center bold">Medición final</td></tr>
      <tr><td>1</td><td>${v(d[`${prefix}_uc_mi1`])}</td><td>1</td><td>${v(d[`${prefix}_uc_mf1`])}</td><td>1</td><td>${v(d[`${prefix}_tm_mi1`])}</td><td>1</td><td>${v(d[`${prefix}_tm_mf1`])}</td></tr>
      <tr><td>2</td><td>${v(d[`${prefix}_uc_mi2`])}</td><td>2</td><td>${v(d[`${prefix}_uc_mf2`])}</td><td>2</td><td>${v(d[`${prefix}_tm_mi2`])}</td><td>2</td><td>${v(d[`${prefix}_tm_mf2`])}</td></tr>
      <tr><td>3</td><td>${v(d[`${prefix}_uc_mi3`])}</td><td>3</td><td>${v(d[`${prefix}_uc_mf3`])}</td><td>3</td><td>${v(d[`${prefix}_tm_mi3`])}</td><td>3</td><td>${v(d[`${prefix}_tm_mf3`])}</td></tr>
      <tr><td>PRO:</td><td>${v(d[`${prefix}_uc_mipro`])}</td><td>PRO:</td><td>${v(d[`${prefix}_uc_mfpro`])}</td><td>PRO:</td><td>${v(d[`${prefix}_tm_mipro`])}</td><td>PRO:</td><td>${v(d[`${prefix}_tm_mfpro`])}</td></tr>
      <tr><td colspan="3">% de cambio dimensional:</td><td>${v(d[`${prefix}_uc_cambio`])}</td><td colspan="3">% de cambio dimensional:</td><td>${v(d[`${prefix}_tm_cambio`])}</td></tr>
    </table>`
  }
  return `<div class="seccion no-break">
  <table style="margin-top:2px">
    <tr>
      <td>NÚMERO DE SOLICITUD: ${v(d.numero_solicitud)}</td>
      <td class="right">MET 7.2-18</td>
    </tr>
  </table>
  <table><tr><td class="titulo-prueba">NMX-A-5077-INNTEX-2015 / NMX-A-6330-INNTEX-2015 DETERMINACIÓN DEL CAMBIO DIMENSIONAL EN EL LAVADO Y EL SECADO</td></tr></table>
  <table style="margin-top:2px">
    <tr>
      <td>FECHA:</td><td>${v(d.fecha)}</td><td>HORA:</td><td>${v(d.hora)}</td>
      <td>° C:</td><td>${v(d.grados)}</td><td>% HR:</td><td>${v(d.hr)}</td>
      <td>TIPO DE CARGA:</td><td>${v(d.tipo_carga)}</td>
      <td>MASA DE CARGA:</td><td>2+0.1 kg</td>
    </tr>
    <tr>
      <td>CICLOS:</td><td>${v(d.ciclos)}</td>
      <td>LAVADO:</td><td>${v(d.lavado)}</td>
      <td>SECADO:</td><td>${v(d.secado)}</td>
      <td>TIPO DE LAVADORA:</td><td>Tipo B</td>
      <td>TIPO DE SECADORA:</td><td>Tipo A3</td>
      <td>DETERGENTE:</td><td>WOB AATCC 1993</td>
    </tr>
  </table>
  <table style="margin-top:2px">
    <tr>
      <td style="padding:0;vertical-align:top">${muestraNested('MUESTRA 1', 'm1')}</td>
      <td style="padding:0;vertical-align:top">${muestraNested('MUESTRA 2', 'm2')}</td>
    </tr>
  </table>
  <table style="margin-top:2px">
    <tr><td>Promedio Urdimbre/ Columnas:</td><td>${v(d.promedio_uc)}</td><td>Promedio Trama/Mallas:</td><td>${v(d.promedio_tm)}</td></tr>
    <tr><td>Redondeo Urdimbre/ Columnas:</td><td>${v(d.redondeo_uc)}</td><td>Redondeo Trama/Mallas:</td><td>${v(d.redondeo_tm)}</td></tr>
    <tr><td>REALIZÓ:</td><td>${v(d.realizo)}</td><td>SUPERVISÓ:</td><td>${v(d.superviso)}</td></tr>
    <tr><td colspan="4" style="text-align:justify">Observaciones: ${v(d.observaciones)}</td></tr>
  </table>
  </div>`
}

// ANÁLISIS QUÍMICO — Tabla 2: 5 cols (already verified correct)
function bitAnalisis(d: any): string {
  const norma: string = d.opcion_nmx || '';

  // MATERIAL NO FIBROSO (APRESTO)
  const pctA = (d.p0 && d.pf && parseFloat(d.p0) !== 0)
    ? (((parseFloat(d.p0) - parseFloat(d.pf)) / parseFloat(d.p0)) * 100).toFixed(2)
    : '';
  const aprestoTable = (d.pretratamiento === 'Si' && (d.p0 || d.pf)) ? `
  <table style="margin-top:4px;width:100%;border-collapse:collapse">
    <tr><th colspan="3" style="border:1px solid #000;padding:3px;text-align:center;background:#eee;font-weight:bold">MATERIAL NO FIBROSO (APRESTO)</th></tr>
    <tr>
      <td style="border:1px solid #000;padding:3px;background:#eee;font-weight:bold;width:33%">P<sub>0</sub></td>
      <td style="border:1px solid #000;padding:3px;width:33%">${v(d.p0)}</td>
      <td style="border:1px solid #000;padding:3px;width:33%"></td>
    </tr>
    <tr>
      <td style="border:1px solid #000;padding:3px;background:#eee;font-weight:bold">P<sub>f</sub></td>
      <td style="border:1px solid #000;padding:3px">${v(d.pf)}</td>
      <td style="border:1px solid #000;padding:3px"></td>
    </tr>
    <tr>
      <td style="border:1px solid #000;padding:3px;background:#eee;font-weight:bold">%A = ((P<sub>0</sub> - P<sub>f</sub>) / P<sub>0</sub>) × 100</td>
      <td style="border:1px solid #000;padding:3px;text-align:center;font-weight:bold">${pctA !== '' ? `${pctA} %` : '—'}</td>
      <td style="border:1px solid #000;padding:3px">${v(d.fibra)}</td>
    </tr>
  </table>` : '';

  // CONTENIDO DE FIBRAS — NMX-1833
  const ro = (d.m0 && d.m1 && d.d && parseFloat(d.m0) !== 0)
    ? ((100 * parseFloat(d.m1) * parseFloat(d.d)) / parseFloat(d.m0)).toFixed(2)
    : '';
  const cs = ro !== '' ? (100 - parseFloat(ro)).toFixed(2) : '';
  const fibras1833Table = (norma.includes('1833') && d.reportar_apresto !== 'solo_apresto') ? `
  <table style="margin-top:4px;width:100%;border-collapse:collapse">
    <tr><th colspan="3" style="border:1px solid #000;padding:3px;text-align:center;background:#eee;font-weight:bold">CONTENIDO DE FIBRAS</th></tr>
    <tr>
      <td style="border:1px solid #000;padding:3px;background:#eee;font-weight:bold;width:33%">m<sub>0</sub></td>
      <td style="border:1px solid #000;padding:3px;width:33%">${v(d.m0)}</td>
      <td style="border:1px solid #000;padding:3px;width:33%"></td>
    </tr>
    <tr>
      <td style="border:1px solid #000;padding:3px;background:#eee;font-weight:bold">m<sub>1</sub></td>
      <td style="border:1px solid #000;padding:3px">${v(d.m1)}</td>
      <td style="border:1px solid #000;padding:3px"></td>
    </tr>
    <tr>
      <td style="border:1px solid #000;padding:3px;background:#eee;font-weight:bold">d</td>
      <td style="border:1px solid #000;padding:3px">${v(d.d)}</td>
      <td style="border:1px solid #000;padding:3px"></td>
    </tr>
    <tr>
      <td style="border:1px solid #000;padding:3px;background:#eee;font-weight:bold">ρ = (100 × m<sub>1</sub> × d) / m<sub>0</sub></td>
      <td style="border:1px solid #000;padding:3px;text-align:center;font-weight:bold">${ro !== '' ? ro : '—'}</td>
      <td style="border:1px solid #000;padding:3px">${v(d.fibra_ro)}</td>
    </tr>
    <tr>
      <td style="border:1px solid #000;padding:3px;background:#eee;font-weight:bold">cs = 100 − ρ</td>
      <td style="border:1px solid #000;padding:3px;text-align:center;font-weight:bold">${cs !== '' ? cs : '—'}</td>
      <td style="border:1px solid #000;padding:3px">${v(d.fibra_cs)}</td>
    </tr>
  </table>` : '';

  // CONTENIDO DE FIBRAS — NMX-084
  const fibras084Table = (norma.includes('084') && d.reportar_apresto !== 'solo_apresto') ? `
  <table style="margin-top:4px;width:100%;border-collapse:collapse">
    <tr><th colspan="2" style="border:1px solid #000;padding:3px;text-align:center;background:#eee;font-weight:bold">CONTENIDO DE FIBRAS</th></tr>
    <tr>
      <td style="border:1px solid #000;padding:3px;background:#eee;font-weight:bold;width:25%">COMBUSTIÓN</td>
      <td style="border:1px solid #000;padding:3px;white-space:pre-wrap">${v(d.combustion)}</td>
    </tr>
    <tr>
      <td style="border:1px solid #000;padding:3px;background:#eee;font-weight:bold">MICROSCOPÍA</td>
      <td style="border:1px solid #000;padding:3px;white-space:pre-wrap">${v(d.microscopia)}</td>
    </tr>
    <tr>
      <td style="border:1px solid #000;padding:3px;background:#eee;font-weight:bold">ANÁLISIS QUÍMICO</td>
      <td style="border:1px solid #000;padding:3px;white-space:pre-wrap">${v(d.analisis_quimico)}</td>
    </tr>
  </table>` : '';

  return `<div class="seccion no-break">
  <table style="margin-top:2px"><tr><td class="titulo-prueba">ANÁLISIS QUÍMICO CUALITATIVO Y CUANTITATIVO</td></tr></table>
  <table style="margin-top:2px">
    <tr>
      <td>NO. DE SOLICITUD: </td><td>${v(d.numero_solicitud)}</td>
      <td>FECHA: </td><td colspan="2">${v(d.fecha)}</td>
    </tr>
    <tr>
      <td colspan="4">${v(d.opcion_nmx)}</td>
      <td>REALIZÓ:  ${v(d.realizo)}</td>
    </tr>
    <tr>
      <td>RESULTADO:</td>
      <td colspan="3" style="white-space:pre-wrap">${v(d.resultado_quimico)}</td>
      <td>SUPERVISÓ:  ${v(d.superviso)}</td>
    </tr>
    <tr><td colspan="5" style="text-align:justify">OBSERVACIONES: ${v(d.observaciones)}</td></tr>
    <tr><td colspan="5">SE REALIZÓ EL PRETRATAMIENTO: ${v(d.pretratamiento)}${d.sustancia ? `, ${v(d.sustancia)}` : ''}</td></tr>
  </table>
  ${aprestoTable}
  ${fibras1833Table}
  ${fibras084Table}
  </div>`
}

// NMX-A-221 — outer wrapper con título+MEQ, inner 4 cols: [colspan=2,rowspan=2 NO.SOL.] [rowspan=2 FECHA:] [fecha] / [REALIZÓ] / [colspan=3 nested] [SUPERVISÓ] / [colspan=4 OBSERVACIONES]
function bitCuero221(d: any): string {
  const dataNested = `<table style="width:100%;border-collapse:collapse">
    <tr><td colspan="2">Masa inicial</td><td>${v(d.masa_inicial)} g</td></tr>
    <tr><td colspan="2">Masa final</td><td>${v(d.masa_final)} g</td></tr>
    <tr><td colspan="2">% grasa y otros materiales solubles</td><td>${v(d.grasa)}</td></tr>
  </table>`
  return `<div class="seccion no-break">
  <table style="width:100%;border-collapse:collapse">
    <tr><td>
      <p class="titulo-prueba">NMX-A-221-1982 Determinación de las grasas y otros materiales solubles por extracción con cloruro de metileno</p>
      <p class="center bold">MEQ-7.2-1</p>
      <table style="width:100%;border-collapse:collapse">
        <tr>
          <td colspan="2" rowspan="2" style="vertical-align:top">NO. DE SOLICITUD:<br>${v(d.numero_solicitud)}</td>
          <td rowspan="2">FECHA:</td>
          <td>${v(d.fecha)}</td>
        </tr>
        <tr><td>REALIZÓ: ${v(d.realizo)}</td></tr>
        <tr>
          <td colspan="3" style="padding:0;vertical-align:top">${dataNested}</td>
          <td>SUPERVISÓ: ${v(d.superviso)}</td>
        </tr>
        <tr><td colspan="4" style="text-align:justify">OBSERVACIONES: ${v(d.observaciones)}</td></tr>
      </table>
    </td></tr>
  </table>
  </div>`
}

function bitCuero225(d: any): string {
  const dataNested = `<table style="width:100%;border-collapse:collapse">
    <tr><td colspan="2">Masa inicial de la muestra antes del secado,</td><td>${v(d.masa_inicial)}</td></tr>
    <tr><td colspan="2">Masa final de la muestra después del secado,</td><td>${v(d.masa_final)}</td></tr>
    <tr><td colspan="2">% de humedad</td><td>${v(d.humedad)}</td></tr>
  </table>`
  return `<div class="seccion no-break">
  <table><tr><td class="titulo-prueba">NMX-A-225-1982 Determinación de humedad en cuero</td></tr></table>
  <table><tr><td class="center bold">MEQ-7.2-2</td></tr></table>
  <table style="margin-top:2px">
    <tr><td colspan="2">NO. DE SOLICITUD: ${v(d.numero_solicitud)}</td><td>FECHA:</td><td>${v(d.fecha)}</td></tr>
    <tr><td colspan="2"></td><td></td><td>REALIZÓ: ${v(d.realizo)}</td></tr>
    <tr>
      <td colspan="3" style="padding:0;vertical-align:top">${dataNested}</td>
      <td>SUPERVISÓ: ${v(d.superviso)}</td>
    </tr>
    <tr><td colspan="4" style="text-align:justify">OBSERVACIONES: ${v(d.observaciones)}</td></tr>
  </table>
  </div>`
}

function bitCuero228(d: any): string {
  const dataNested = `<table style="width:100%;border-collapse:collapse">
    <tr><td colspan="2">Masa de cenizas insolubles en agua</td><td>${v(d.cenizas_insolubles)} g</td></tr>
    <tr><td colspan="2">Masa de cenizas totales sulfatadas,</td><td>${v(d.cenizas_sulfatadas)} g</td></tr>
    <tr><td colspan="2">Masa inicial de la muestra,</td><td>${v(d.masa_inicial)} g</td></tr>
    <tr><td colspan="2">% de cenizas totales sulfatadas</td><td>${v(d.cenizas_totales)}</td></tr>
  </table>`
  return `<div class="seccion no-break">
  <table style="width:100%;border-collapse:collapse">
    <tr><td>
      <p class="titulo-prueba">NMX-A-228-1982 Determinación de cenizas totales y cenizas insolubles en agua</p>
      <p class="center bold">MEQ-7.2-3</p>
      <table style="width:100%;border-collapse:collapse">
        <tr>
          <td>NO. DE SOLICITUD:</td><td>${v(d.numero_solicitud)}</td>
          <td>FECHA:</td><td>${v(d.fecha)}</td>
        </tr>
        <tr>
          <td colspan="2">PRESENCIA DE CENIZAS INSOLUBLES EN AGUA</td>
          <td>${v(d.cenizas_agua)}</td>
          <td>REALIZÓ: ${v(d.realizo)}</td>
        </tr>
        <tr>
          <td colspan="3" style="padding:0;vertical-align:top">${dataNested}</td>
          <td>SUPERVISÓ: ${v(d.superviso)}</td>
        </tr>
        <tr><td colspan="4" style="text-align:justify">OBSERVACIONES: ${v(d.observaciones)}</td></tr>
      </table>
    </td></tr>
  </table>
  </div>`
}

function bitCuero229(d: any): string {
  const dataNested = `<table style="width:100%;border-collapse:collapse">
    <tr><td colspan="2">pH solución inicial (extracto de cuero)</td><td>${v(d.sol_inicial)}</td></tr>
    <tr><td colspan="2">pH solución diluida</td><td>${v(d.sol_diluida)}</td></tr>
    <tr><td colspan="2">Δ pH</td><td>${v(d.ph)}</td></tr>
  </table>`
  return `<div class="seccion no-break">
  <table style="width:100%;border-collapse:collapse">
    <tr><td>
      <p class="titulo-prueba">NMX-A-229-1982 Determinación del pH y Δ pH de un extracto acuoso de cuero</p>
      <p class="center bold">MEQ-7.2-5</p>
      <table style="width:100%;border-collapse:collapse">
        <tr>
          <td>NO. DE SOLICITUD:</td><td>${v(d.numero_solicitud)}</td>
          <td>FECHA:</td><td>${v(d.fecha)}</td>
        </tr>
        <tr>
          <td colspan="2">TIEMPO DE AGITACIÓN: ${v(d.tiempo_agitacion)}</td>
          <td colspan="2">REALIZÓ: ${v(d.realizo)}</td>
        </tr>
        <tr>
          <td colspan="3" style="padding:0;vertical-align:top">${dataNested}</td>
          <td>SUPERVISÓ: ${v(d.superviso)}</td>
        </tr>
        <tr><td colspan="4" style="text-align:justify">OBSERVACIONES: ${v(d.observaciones)}</td></tr>
      </table>
    </td></tr>
  </table>
  </div>`
}

function bitCuero230(d: any): string {
  const dataNested = `<table style="width:100%;border-collapse:collapse">
    <tr><td colspan="2">Masa del cuero, G</td><td>${v(d.masa_cuero)} g</td></tr>
    <tr><td colspan="2">Volumen de tiosulfato de sodio empleados, V</td><td>${v(d.tiosulfato)} ml</td></tr>
    <tr><td colspan="2">% de cromo</td><td>${v(d.cromo)}</td></tr>
  </table>`
  return `<div class="seccion no-break">
  <table style="width:100%;border-collapse:collapse">
    <tr><td>
      <p class="titulo-prueba">NMX-A-230-1982 Determinación del contenido de cromo</p>
      <p class="center bold">MEQ-7.2-4</p>
      <table style="width:100%;border-collapse:collapse">
        <tr>
          <td>NO. DE SOLICITUD:</td><td>${v(d.numero_solicitud)}</td>
          <td>FECHA:</td><td>${v(d.fecha)}</td>
        </tr>
        <tr>
          <td colspan="3">MÉTODO: ÁCIDO PERCLÓRICO</td>
          <td>REALIZÓ: ${v(d.realizo)}</td>
        </tr>
        <tr>
          <td colspan="3" style="padding:0;vertical-align:top">${dataNested}</td>
          <td>SUPERVISÓ: ${v(d.superviso)}</td>
        </tr>
        <tr><td colspan="4" style="text-align:justify">OBSERVACIONES: ${v(d.observaciones)}</td></tr>
      </table>
    </td></tr>
  </table>
  </div>`
}

// NMX-A-105-D01 — SOLIDEZ DEL COLOR AL LAVADO EN SECO
function bit105d01(d: any): string {
  const dwRows = [
    ['diacetato', 'diacetato_dw'], ['ALGODÓN blanqueado', 'algodon_dw'],
    ['poliamida', 'poliamida_dw'], ['poliéster', 'poliester_dw'],
    ['acrílico', 'acrilico_dw'], ['LANA', 'lana_dw'], ['Cambio de color:', 'cambio_color_dw'],
  ]
  const tvRows = [
    ['triacetato', 'triacetato_tv'], ['ALGODÓN blanqueado', 'algodon_tv'],
    ['poliamida', 'poliamida_tv'], ['poliéster', 'poliester_tv'],
    ['acrílico', 'acrilico_tv'], ['viscosa', 'viscosa_tv'], ['Cambio de color:', 'cambio_color_tv'],
  ]
  const showDW = !d.multifibra || d.multifibra.includes('DW')
  const showTV = !d.multifibra || d.multifibra.includes('TV')
  const S = 'style="border:1px solid #000;border-collapse:collapse;width:100%"'
  const dw = showDW ? `<table ${S}>
    <tr><td colspan="2" class="center bold">TELA MULTIFIBRA DW</td></tr>
    <tr><td class="bold">Fibra</td><td class="center bold">Transferencia</td></tr>
    ${dwRows.map(([label, field]) => `<tr><td>${label}</td><td class="center">${v((d as any)[field])}</td></tr>`).join('')}
  </table>` : ''
  const tv = showTV ? `<table ${S}>
    <tr><td colspan="2" class="center bold">TELA MULTIFIBRA TV</td></tr>
    <tr><td class="bold">Fibra</td><td class="center bold">Transferencia</td></tr>
    ${tvRows.map(([label, field]) => `<tr><td>${label}</td><td class="center">${v((d as any)[field])}</td></tr>`).join('')}
  </table>` : ''
  const numCols = (showDW ? 1 : 0) + (showTV ? 1 : 0) + 1
  return `<div class="seccion no-break">
  <table style="margin-top:2px">
    <tr>
      <td colspan="3" style="border:1px solid #000;padding:2px 5px"><strong>NUMERO DE SOLICITUD:</strong> ${v(d.numero_solicitud)}</td>
      <td style="border:1px solid #000;padding:2px 5px"><strong>FECHA:</strong> ${v(d.fecha)}</td>
    </tr>
    <tr>
      <td colspan="3" style="border:1px solid #000;padding:2px 5px;text-align:center;font-weight:bold">NMX-A-105-D01-INNTEX-2020 SOLIDEZ DEL COLOR AL LAVADO EN SECO</td>
      <td style="border:1px solid #000;padding:2px 5px;text-align:center;font-weight:bold">MET-7.2-22</td>
    </tr>
    <tr>
      <td colspan="4" style="border:1px solid #000;padding:2px 5px">Solvente utilizado: <u>${v(d.solvente) || 'Percloroetileno'}</u></td>
    </tr>
    <tr>
      ${showDW && showTV
        ? `<td style="border:1px solid #000;padding:0;vertical-align:top">${dw}</td>
           <td style="border:1px solid #000;padding:0;vertical-align:top">${tv}</td>
           <td colspan="2" style="border:1px solid #000;padding:4px 8px;vertical-align:top">
             Realizó:<br><br>${v(d.realizo)}<br><br>Autorizó:<br><br>${v(d.autorizo)}
           </td>`
        : `<td colspan="3" style="border:1px solid #000;padding:0;vertical-align:top">${showDW ? dw : tv}</td>
           <td style="border:1px solid #000;padding:4px 8px;vertical-align:top">
             Realizó:<br><br>${v(d.realizo)}<br><br>Autorizó:<br><br>${v(d.autorizo)}
           </td>`
      }
    </tr>
    ${v(d.observaciones) ? `<tr>
      <td colspan="4" style="border:1px solid #000;padding:2px 5px;text-align:justify">Notas: ${v(d.observaciones)}</td>
    </tr>` : ''}
  </table>
  </div>`
}

// NMX-A-105-B02 — SOLIDEZ DEL COLOR A LA LUZ ARTIFICIAL (XENÓN)
function bit105b02(d: any): string {
  const condTable = `<table style="width:80%;border-collapse:collapse;margin-left:8px">
    <tr>
      <td style="border:1px solid #000;padding:2px 5px;width:35%">Ciclo de exposición:</td>
      <td style="border:1px solid #000;padding:2px 5px;width:15%">${v(d.ciclo_exposicion)}</td>
      <td style="border:1px solid #000;padding:2px 5px;width:35%">Temperatura del estándar negro (°C):</td>
      <td style="border:1px solid #000;padding:2px 5px;width:15%">${v(d.temp_estandar_negro)}</td>
    </tr>
    <tr>
      <td style="border:1px solid #000;padding:2px 5px">Temperatura del panel negro (°C):</td>
      <td style="border:1px solid #000;padding:2px 5px">${v(d.temp_panel_negro)}</td>
      <td style="border:1px solid #000;padding:2px 5px">Humedad relativa (%):</td>
      <td style="border:1px solid #000;padding:2px 5px">${v(d.humedad_relativa)}</td>
    </tr>
    <tr>
      <td style="border:1px solid #000;padding:2px 5px">Irradiación (W/m²·nm):</td>
      <td style="border:1px solid #000;padding:2px 5px">${v(d.irradiacion)}</td>
      <td style="border:1px solid #000;padding:2px 5px">Longitud de onda:</td>
      <td style="border:1px solid #000;padding:2px 5px">${v(d.longitud_onda)}</td>
    </tr>
  </table>`
  const resTable = `<table style="width:55%;border-collapse:collapse;margin-left:24px;margin-top:4px">
    <tr>
      <td style="border:1px solid #000;padding:2px 5px;width:60%">Exposición radiante (kJ/m²):</td>
      <td style="border:1px solid #000;padding:2px 5px">${v(d.exposicion_radiante)}</td>
    </tr>
    <tr>
      <td style="border:1px solid #000;padding:2px 5px">Tiempo de exposición (horas):</td>
      <td style="border:1px solid #000;padding:2px 5px">${v(d.tiempo_exposicion)}</td>
    </tr>
    <tr>
      <td style="border:1px solid #000;padding:2px 5px"><strong>Grado de escala de gris</strong><br><strong>(CAMBIO DE COLOR):</strong></td>
      <td style="border:1px solid #000;padding:2px 5px">${v(d.grado_escala_gris)}</td>
    </tr>
  </table>`
  return `<div class="seccion no-break">
  <table style="margin-top:2px">
    <tr>
      <td colspan="3"><strong>NUMERO DE SOLICITUD:</strong> ${v(d.numero_solicitud)}</td>
      <td><strong>FECHA:</strong> ${v(d.fecha)}</td>
    </tr>
    <tr>
      <td colspan="3" class="center bold">NMX-A-105-B02-INNTEX-2019 DETERMINACIÓN DE LA SOLIDEZ DEL COLOR A LA LUZ<br>ARTIFICIAL: ENSAYO DE LA LÁMPARA DE DECOLORACIÓN DE ARCO DE XENÓN</td>
      <td class="center bold">MET-7.2-23</td>
    </tr>
    <tr>
      <td colspan="3" style="vertical-align:top;padding:4px">
        <div style="font-size:8.5pt;margin-bottom:4px">
          Equipo: <u>Enfriado por agua</u>&nbsp;&nbsp;
          Método: <u>5</u>&nbsp;&nbsp;
          Modo oscilante: <u>NO</u>&nbsp;&nbsp;
          Iluminante (evaluación): <u>D65</u>
        </div>
        <div style="font-size:8.5pt;margin-bottom:2px">Condiciones de exposición:</div>
        ${condTable}
        ${resTable}
      </td>
      <td style="vertical-align:top;padding:4px">
        Realizó:<br><br><br>${v(d.realizo)}<br><br>
        Autorizó:<br><br><br>${v(d.autorizo)}
      </td>
    </tr>
    ${v(d.observaciones) ? `<tr>
      <td colspan="4" style="text-align:justify">Notas: ${v(d.observaciones)}</td>
    </tr>` : ''}
  </table>
  </div>`
}

function bCalcDesv(vals: string[]): string {
  const nums = vals.map((v: string) => parseFloat(v)).filter((n: number) => !isNaN(n))
  if (nums.length < 2) return ''
  const mean = nums.reduce((a: number, b: number) => a + b, 0) / nums.length
  const variance = nums.reduce((s: number, x: number) => s + Math.pow(x - mean, 2), 0) / (nums.length - 1)
  return Math.sqrt(variance).toFixed(3)
}
const B_T_TABLE: Record<number, number> = { 2: 12.706, 3: 4.303, 4: 3.182, 5: 2.776, 6: 2.571, 7: 2.447, 8: 2.365, 9: 2.306, 10: 2.262 }
function bDesv059_2(d: any, dir: 'u'|'t'): string {
  return bCalcDesv([1,2,3,4,5].map(i => d[`no${i}_${dir}`] || ''))
}
function bCV059_2(d: any, dir: 'u'|'t'): string {
  const prom = parseFloat(dir === 'u' ? d.promedio_u : d.promedio_t)
  const desv = parseFloat(bDesv059_2(d, dir))
  if (!prom || !desv || isNaN(prom) || isNaN(desv)) return ''
  return ((desv / prom) * 100).toFixed(2)
}
function bLC95_059_2(d: any, dir: 'u'|'t'): string {
  const vals = [1,2,3,4,5].map(i => d[`no${i}_${dir}`] || '')
  const desv = parseFloat(bDesv059_2(d, dir))
  const n = vals.filter((v: string) => v !== '' && !isNaN(parseFloat(v))).length
  if (!desv || isNaN(desv) || n < 2) return ''
  return ((B_T_TABLE[n] ?? 2.776) * desv / Math.sqrt(n)).toFixed(3)
}

// NMX-A-059/2 — MÉTODO GRAB
function bit059_2(d: any): string {
  const estado = typeof d.estado_especimenes === 'string'
    ? d.estado_especimenes.split(',').map((s: string) => s.trim()).filter(Boolean)
    : Array.isArray(d.estado_especimenes) ? d.estado_especimenes : []

  const ck = (opt: string) => estado.includes(opt) ? '☑' : '☐'

  const S = 'border:1px solid #000;padding:3px 6px;font-size:8.5pt;vertical-align:middle'
  const SB = `${S};font-weight:bold`
  const SC = `${S};text-align:center`
  const SCB = `${S};text-align:center;font-weight:bold`

  const medTable = `<table style="border-collapse:collapse;width:100%">
    <tr>
      <td style="${SB};width:25%">No.</td>
      <td style="${SCB}">Urdimbre</td>
      <td style="${SCB}">Trama</td>
    </tr>
    ${[1,2,3,4,5].map(i => `<tr>
      <td style="${S}">${i}</td>
      <td style="${SC}">${v(d[`no${i}_u`])}</td>
      <td style="${SC}">${v(d[`no${i}_t`])}</td>
    </tr>`).join('')}
    <tr>
      <td style="${SB}">Promedio</td>
      <td style="${SC}">${v(d.promedio_u)}</td>
      <td style="${SC}">${v(d.promedio_t)}</td>
    </tr>
    <tr>
      <td style="${SB}">Redondeo</td>
      <td style="${SCB}">${v(d.redondeo_u) ? `${v(d.redondeo_u)} N` : 'N'}</td>
      <td style="${SCB}">${v(d.redondeo_t) ? `${v(d.redondeo_t)} N` : 'N'}</td>
    </tr>
    <tr>
      <td style="${SB}">σ</td>
      <td style="${SC}">${bDesv059_2(d, 'u')}</td>
      <td style="${SC}">${bDesv059_2(d, 't')}</td>
    </tr>
    ${d.reportar !== false && d.reportar !== 'false' ? `<tr>
      <td style="${SB}">CV (%)</td>
      <td style="${SC}">${bCV059_2(d, 'u')}</td>
      <td style="${SC}">${bCV059_2(d, 't')}</td>
    </tr>
    <tr>
      <td style="${SB}">LC 95%</td>
      <td style="${SC}">${bLC95_059_2(d, 'u')}</td>
      <td style="${SC}">${bLC95_059_2(d, 't')}</td>
    </tr>` : ''}
  </table>`

  return `<div class="seccion no-break">
  <table>
    <tr>
      <td colspan="5" style="${S}"><strong>NÚMERO DE SOLICITUD:</strong> ${v(d.numero_solicitud)}</td>
    </tr>
    <tr>
      <td colspan="4" class="titulo-prueba" style="font-size:9pt;padding:4px 6px">Propiedades de los tejidos frente a la tracción-Parte 2: Determinación de la fuerza máxima por el método de agarre-Método Grab. NMX-059/2-INNTEX-2019</td>
      <td style="${SCB};white-space:nowrap">MET-7.2-20</td>
    </tr>
    <tr>
      <td style="${S}">Fecha: ${v(d.fecha)}</td>
      <td style="${S}">Hora: ${v(d.hora)}</td>
      <td style="${S}">°C: ${v(d.temperatura)}</td>
      <td style="${S}">%H.R.: ${v(d.hr)}</td>
      <td style="${S}">ID de termohigrómetro: ${v(d.id_termohigrometro)}</td>
    </tr>
    <tr>
      <td colspan="2" style="${S}">Especímenes ensayados: ${v(d.especimenes_u)} en U y ${v(d.especimenes_t)} en T.</td>
      <td colspan="2" style="${S}">Longitud del ensayo: ${v(d.longitud_ensayo)} mm</td>
      <td style="${S}">Especímenes rechazados: ${v(d.especimenes_rechazados)}</td>
    </tr>
    <tr>
      <td style="${S}">Estado de los especímenes:</td>
      <td colspan="4" style="${S}">${ck('Acondicionados')} Acondicionados &nbsp;&nbsp; ${ck('Húmedos')} Húmedos</td>
    </tr>
    ${d.tiene_metodo_muestreo ? `<tr>
      <td style="${S}">Método de toma de muestreo:</td>
      <td colspan="4" style="${S}">${v(d.metodo_muestreo)}</td>
    </tr>` : ''}
    <tr>
      <td colspan="3" style="border:1px solid #000;padding:4px;vertical-align:top">${medTable}</td>
      <td colspan="2" style="border:1px solid #000;padding:6px;vertical-align:top">
        <div style="font-size:8.5pt;margin-bottom:24px">Realizó: ${v(d.realizo)}</div>
        <div style="font-size:8.5pt">Supervisó: ${v(d.superviso)}</div>
      </td>
    </tr>
    ${v(d.observaciones) ? `<tr>
      <td colspan="5" style="${S};text-align:justify">Notas: ${v(d.observaciones)}</td>
    </tr>` : ''}
  </table>
  </div>`
}

// NMX-A-059/1 — MÉTODO TIRA
function bit059_1(d: any): string {
  const tablas = typeof d.tablas_activas === 'string'
    ? d.tablas_activas.split(',').map((s: string) => s.trim()).filter(Boolean)
    : Array.isArray(d.tablas_activas) ? d.tablas_activas : ['fm', 'fr', 'afm', 'ar']

  const estado = typeof d.estado_especimenes === 'string'
    ? d.estado_especimenes.split(',').map((s: string) => s.trim()).filter(Boolean)
    : Array.isArray(d.estado_especimenes) ? d.estado_especimenes : []

  const ESTADO_OPTS = ['Acondicionados', 'Húmedos', 'Con tensión previa', 'Relajados']

  const TABLE_LABELS: Record<string, { label: string; unit: string }> = {
    fm:  { label: 'FUERZA MÁXIMA',                  unit: 'N' },
    fr:  { label: 'FUERZA A LA ROTURA',              unit: 'N' },
    afm: { label: 'ALARGAMIENTO A LA FUERZA MÁXIMA', unit: '%' },
    ar:  { label: 'ALARGAMIENTO A LA ROTURA',         unit: '%' },
  }

  const subTabla = (t: string) => {
    const info = TABLE_LABELS[t] || { label: t.toUpperCase(), unit: '' }
    const uVals = [1,2,3,4,5].map(i => d[`${t}_u${i}`] || '')
    const tVals = [1,2,3,4,5].map(i => d[`${t}_t${i}`] || '')
    const dU = bCalcDesv(uVals); const dT = bCalcDesv(tVals)
    const pU = parseFloat(d[`${t}_prom_u`]); const pT = parseFloat(d[`${t}_prom_t`])
    const cvU = (dU && pU && !isNaN(pU)) ? ((parseFloat(dU) / pU) * 100).toFixed(2) : ''
    const cvT = (dT && pT && !isNaN(pT)) ? ((parseFloat(dT) / pT) * 100).toFixed(2) : ''
    const nU = uVals.filter(x => x !== '' && !isNaN(parseFloat(x))).length
    const nT = tVals.filter(x => x !== '' && !isNaN(parseFloat(x))).length
    const lU = (dU && nU >= 2) ? (((B_T_TABLE[nU] ?? 2.776) * parseFloat(dU)) / Math.sqrt(nU)).toFixed(3) : ''
    const lT = (dT && nT >= 2) ? (((B_T_TABLE[nT] ?? 2.776) * parseFloat(dT)) / Math.sqrt(nT)).toFixed(3) : ''
    const reportaCV = d.reportar !== false && d.reportar !== 'false'
    return `<table style="border-collapse:collapse;width:100%">
      <tr><td colspan="3" style="border:1px solid #000;text-align:center;font-weight:bold;padding:3px 6px;font-size:8.5pt">${info.label}</td></tr>
      <tr>
        <td style="border:1px solid #000;font-weight:bold;padding:3px 6px;font-size:8.5pt;width:25%">No.</td>
        <td style="border:1px solid #000;font-weight:bold;text-align:center;padding:3px 6px;font-size:8.5pt">Urdimbre</td>
        <td style="border:1px solid #000;font-weight:bold;text-align:center;padding:3px 6px;font-size:8.5pt">Trama</td>
      </tr>
      ${[1,2,3,4,5].map(i => `<tr>
        <td style="border:1px solid #000;padding:3px 6px;font-size:8.5pt">${i}</td>
        <td style="border:1px solid #000;text-align:center;padding:3px 6px;font-size:8.5pt">${v(d[`${t}_u${i}`])}</td>
        <td style="border:1px solid #000;text-align:center;padding:3px 6px;font-size:8.5pt">${v(d[`${t}_t${i}`])}</td>
      </tr>`).join('')}
      <tr>
        <td style="border:1px solid #000;font-weight:bold;padding:3px 6px;font-size:8.5pt">Promedio</td>
        <td style="border:1px solid #000;text-align:center;padding:3px 6px;font-size:8.5pt">${v(d[`${t}_prom_u`])}</td>
        <td style="border:1px solid #000;text-align:center;padding:3px 6px;font-size:8.5pt">${v(d[`${t}_prom_t`])}</td>
      </tr>
      <tr>
        <td style="border:1px solid #000;font-weight:bold;padding:3px 6px;font-size:8.5pt">Redondeo</td>
        <td style="border:1px solid #000;font-weight:bold;text-align:center;padding:3px 6px;font-size:8.5pt">${v(d[`${t}_red_u`]) ? `${v(d[`${t}_red_u`])} ${info.unit}` : info.unit}</td>
        <td style="border:1px solid #000;font-weight:bold;text-align:center;padding:3px 6px;font-size:8.5pt">${v(d[`${t}_red_t`]) ? `${v(d[`${t}_red_t`])} ${info.unit}` : info.unit}</td>
      </tr>
      <tr>
        <td style="border:1px solid #000;font-weight:bold;padding:3px 6px;font-size:8.5pt">σ</td>
        <td style="border:1px solid #000;text-align:center;padding:3px 6px;font-size:8.5pt">${dU}</td>
        <td style="border:1px solid #000;text-align:center;padding:3px 6px;font-size:8.5pt">${dT}</td>
      </tr>
      ${reportaCV ? `<tr>
        <td style="border:1px solid #000;font-weight:bold;padding:3px 6px;font-size:8.5pt">CV (%)</td>
        <td style="border:1px solid #000;text-align:center;padding:3px 6px;font-size:8.5pt">${cvU}</td>
        <td style="border:1px solid #000;text-align:center;padding:3px 6px;font-size:8.5pt">${cvT}</td>
      </tr>
      <tr>
        <td style="border:1px solid #000;font-weight:bold;padding:3px 6px;font-size:8.5pt">LC 95%</td>
        <td style="border:1px solid #000;text-align:center;padding:3px 6px;font-size:8.5pt">${lU}</td>
        <td style="border:1px solid #000;text-align:center;padding:3px 6px;font-size:8.5pt">${lT}</td>
      </tr>` : ''}
    </table>`
  }

  // Pair active tables: [fm,fr] and [afm,ar] (only active ones)
  const pares: [string, string | null][] = []
  for (let i = 0; i < tablas.length; i += 2) {
    pares.push([tablas[i], tablas[i + 1] ?? null])
  }

  const tablasHTML = pares.map(([a, b]) => `
    <tr>
      <td style="border:none;padding:4px 2px;width:50%;vertical-align:top">${subTabla(a)}</td>
      <td style="border:none;padding:4px 2px;width:50%;vertical-align:top">${b ? subTabla(b) : ''}</td>
    </tr>`).join('')

  return `<div class="seccion no-break">
  <table>
    <tr><td colspan="5" style="border:1px solid #000;padding:4px 6px;font-size:8.5pt"><strong>NÚMERO DE SOLICITUD:</strong> ${v(d.numero_solicitud)}</td></tr>
    <tr>
      <td colspan="4" class="titulo-prueba" style="font-size:10pt;padding:4px 6px">NMX-A-059/1-INNTEX-2019 DETERMINACIÓN DE LA FUERZA MÁXIMA Y DEL ALARGAMIENTO A LA FUERZA MÁXIMA POR EL MÉTODO DE LA TIRA</td>
      <td class="bold center" style="white-space:nowrap;padding:4px 6px">MET-7.2-24</td>
    </tr>
    <tr>
      <td style="font-size:8.5pt;padding:3px 6px">Fecha: ${v(d.fecha)}</td>
      <td style="font-size:8.5pt;padding:3px 6px">Hora: ${v(d.hora)}</td>
      <td style="font-size:8.5pt;padding:3px 6px">Temperatura(°C) ${v(d.temperatura)}</td>
      <td style="font-size:8.5pt;padding:3px 6px">Humedad relativa (%) ${v(d.hr)}</td>
      <td style="font-size:8.5pt;padding:3px 6px">ID de termohigrómetro: ${v(d.id_termohigrometro)}</td>
    </tr>
    <tr>
      <td colspan="2" style="font-size:8.5pt;padding:3px 6px">Longitud del ensayo (mm): ${v(d.longitud_ensayo)}</td>
      <td colspan="2" style="font-size:8.5pt;padding:3px 6px">Velocidad de alargamiento (mm/min): ${v(d.velocidad_alargamiento)}</td>
      <td style="font-size:8.5pt;padding:3px 6px">Ancho de la tira(mm): ${v(d.ancho_tira)}</td>
    </tr>
    <tr>
      <td rowspan="4" style="font-size:8.5pt;padding:3px 6px;vertical-align:top">Estado de los<br>especímenes:</td>
      <td style="font-size:8.5pt;padding:3px 6px">${estado.includes('Acondicionados') ? '☑' : '☐'} Acondicionados</td>
      <td colspan="2" rowspan="4" style="font-size:8.5pt;padding:3px 6px;vertical-align:top">
        Número de especímenes ensayados: ${v(d.num_especimenes)}<br>
        Especímenes rechazados: ${v(d.especimenes_rechazados)}
      </td>
      <td rowspan="4" style="font-size:8.5pt;padding:3px 6px;vertical-align:top">Número de hilos(tira): ${v(d.num_hilos_tira)}</td>
    </tr>
    <tr>
      <td style="font-size:8.5pt;padding:3px 6px">${estado.includes('Húmedos') ? '☑' : '☐'} Húmedos</td>
    </tr>
    <tr>
      <td style="font-size:8.5pt;padding:3px 6px">${estado.includes('Con tensión previa') ? '☑' : '☐'} Con tensión previa</td>
    </tr>
    <tr>
      <td style="font-size:8.5pt;padding:3px 6px">${estado.includes('Relajados') ? '☑' : '☐'} Relajados</td>
    </tr>
  </table>
  ${d.tiene_metodo_muestreo ? `<table style="margin-top:4px;border-collapse:collapse;width:100%"><tr>
    <td style="border:1px solid #000;font-weight:bold;padding:3px 6px;font-size:8.5pt;width:35%">Método de toma de muestreo:</td>
    <td style="border:1px solid #000;padding:3px 6px;font-size:8.5pt">${v(d.metodo_muestreo)}</td>
  </tr></table>` : ''}
  <table style="margin-top:6px;border-collapse:collapse;width:100%">
    ${tablasHTML}
  </table>
  <table style="margin-top:6px">
    <tr>
      <td style="font-size:8.5pt;padding:4px 6px;width:50%">Realizó: ${v(d.realizo)}</td>
      <td style="font-size:8.5pt;padding:4px 6px;width:50%">Supervisó: ${v(d.superviso)}</td>
    </tr>
    ${v(d.observaciones) ? `<tr><td colspan="2" style="font-size:8.5pt;padding:4px 6px;text-align:justify">Notas: ${v(d.observaciones)}</td></tr>` : ''}
  </table>
  </div>`
}

// AATCC TM127 — HYDROSTATIC PRESSURE
function bitAATCC127(d: any): string {
  const innerTable = `<table style="width:60%;margin:0 auto;border-collapse:collapse">
    <tr>
      <td style="border:1px solid #000;padding:2px 6px;text-align:center;font-weight:bold;font-size:8pt">No.</td>
      <td style="border:1px solid #000;padding:2px 6px;text-align:center;font-weight:bold;font-size:8pt">Presión hidrostática</td>
    </tr>
    <tr>
      <td style="border:1px solid #000;padding:2px 6px;text-align:center;font-size:8pt">1</td>
      <td style="border:1px solid #000;padding:2px 6px;text-align:center;font-size:8pt">${v(d.no1)}</td>
    </tr>
    <tr>
      <td style="border:1px solid #000;padding:2px 6px;text-align:center;font-size:8pt">2</td>
      <td style="border:1px solid #000;padding:2px 6px;text-align:center;font-size:8pt">${v(d.no2)}</td>
    </tr>
    <tr>
      <td style="border:1px solid #000;padding:2px 6px;text-align:center;font-size:8pt">3</td>
      <td style="border:1px solid #000;padding:2px 6px;text-align:center;font-size:8pt">${v(d.no3)}</td>
    </tr>
    <tr>
      <td style="border:1px solid #000;padding:2px 6px;font-size:8pt;font-weight:bold">Promedio</td>
      <td style="border:1px solid #000;padding:2px 6px;text-align:center;font-size:8pt;font-weight:bold">${v(d.promedio)} cm/H₂O</td>
    </tr>
  </table>`

  return `<div class="seccion no-break">
  <table style="margin-top:2px"><tr><td>NÚMERO DE SOLICITUD: ${v(d.numero_solicitud)}</td></tr></table>
  <table>
    <tr>
      <td colspan="4" style="border:1px solid #000;padding:3px 6px;font-size:9pt;font-weight:bold">AATCC TM127-2017(2018) e TEST METHOD FOR WATER RESISTANCE: HYDROSTATIC PRESSURE</td>
      <td style="border:1px solid #000;padding:3px 6px;font-size:8.5pt;font-weight:bold;white-space:nowrap;text-align:right">MET-7.2-21</td>
    </tr>
    <tr>
      <td style="border:1px solid #000;padding:2px 5px;font-size:8pt">Fecha: ${v(d.fecha)}</td>
      <td style="border:1px solid #000;padding:2px 5px;font-size:8pt">Hora: ${v(d.hora)}</td>
      <td style="border:1px solid #000;padding:2px 5px;font-size:8pt">°C: ${v(d.temperatura)}</td>
      <td style="border:1px solid #000;padding:2px 5px;font-size:8pt">%H.R.: ${v(d.hr)}</td>
      <td style="border:1px solid #000;padding:2px 5px;font-size:8pt">ID de termohigrómetro: ${v(d.id_termohigrometro)}</td>
    </tr>
    <tr>
      <td style="border:1px solid #000;padding:2px 5px;font-size:8pt">Tipo de material: ${v(d.tipo_material)}</td>
      <td style="border:1px solid #000;padding:2px 5px;font-size:8pt">Tipo de agua: ${v(d.tipo_agua)}</td>
      <td style="border:1px solid #000;padding:2px 5px;font-size:8pt">Temperatura del agua: ${v(d.temp_agua)} °C</td>
      <td colspan="2" style="border:1px solid #000;padding:2px 5px;font-size:8pt">Cara delantera probada: ${v(d.cara_delantera)}</td>
    </tr>
    <tr>
      <td style="border:1px solid #000;padding:2px 5px;font-size:8pt">Gradiente: <strong>60 mbar/min</strong></td>
      <td style="border:1px solid #000;padding:2px 5px;font-size:8pt">Tipo de equipo:</td>
      <td colspan="3" style="border:1px solid #000;padding:2px 5px;font-size:8pt;font-weight:bold">Equipo de cabeza hidrostática (opción 2)</td>
    </tr>
    <tr>
      <td colspan="3" style="border:1px solid #000;padding:8px 4px;text-align:center;vertical-align:middle">
        ${innerTable}
      </td>
      <td colspan="2" style="border:1px solid #000;padding:6px 8px;vertical-align:top;font-size:8.5pt">
        <div style="margin-bottom:24px">Realizó: ${v(d.realizo)}</div>
        <div>Supervisó: ${v(d.superviso)}</div>
      </td>
    </tr>
    <tr>
      <td colspan="5" style="border:1px solid #000;padding:3px 6px;font-size:8.5pt;text-align:justify">Notas: ${v(d.observaciones)}</td>
    </tr>
  </table>
  </div>`
}

// NMX-S-051 — RESISTENCIA A LA FLEXIÓN
function bitS051(d: any): string {
  const secoFilas: [number, string][] = [[100,'seco_100'],[1000,'seco_1000'],[10000,'seco_10000'],[20000,'seco_20000'],[48000,'seco_48000']]
  const humFilas:  [number, string][] = [[100,'hum_100'],[1000,'hum_1000'],[10000,'hum_10000'],[18000,'hum_18000']]

  const evalTable = `<table style="width:85%;border-collapse:collapse;margin-left:8px">
    <tr><td colspan="6" style="border:1px solid #000;padding:2px 5px;text-align:center;font-weight:bold">EVALUACIÓN</td></tr>
    <tr>
      <td colspan="3" style="border:1px solid #000;padding:2px 5px;text-align:center;font-style:italic">Seco (acondicionado), 2 muestras</td>
      <td colspan="3" style="border:1px solid #000;padding:2px 5px;text-align:center;font-style:italic">Húmedo, 2 muestras</td>
    </tr>
    <tr>
      <td rowspan="2" style="border:1px solid #000;padding:2px 5px">Ciclos</td>
      <td colspan="2" style="border:1px solid #000;padding:2px 5px;text-align:center">Evaluación</td>
      <td rowspan="2" style="border:1px solid #000;padding:2px 5px">Ciclos</td>
      <td colspan="2" style="border:1px solid #000;padding:2px 5px;text-align:center">Evaluación</td>
    </tr>
    <tr>
      <td style="border:1px solid #000;padding:2px 5px;text-align:center">Con daño</td>
      <td style="border:1px solid #000;padding:2px 5px;text-align:center">Tipo de daño</td>
      <td style="border:1px solid #000;padding:2px 5px;text-align:center">Con daño</td>
      <td style="border:1px solid #000;padding:2px 5px;text-align:center">Tipo de daño</td>
    </tr>
    ${secoFilas.map(([c, k], i) => {
      const hf = humFilas[i]
      return `<tr>
        <td style="border:1px solid #000;padding:2px 5px">${c.toLocaleString()}</td>
        <td style="border:1px solid #000;padding:2px 5px;text-align:center">${v(d[k+'_con'])}</td>
        <td style="border:1px solid #000;padding:2px 5px;text-align:center">${v(d[k+'_sin'])}</td>
        <td style="border:1px solid #000;padding:2px 5px">${hf ? hf[0].toLocaleString() : ''}</td>
        <td style="border:1px solid #000;padding:2px 5px;text-align:center">${hf ? v(d[hf[1]+'_con']) : ''}</td>
        <td style="border:1px solid #000;padding:2px 5px;text-align:center">${hf ? v(d[hf[1]+'_sin']) : ''}</td>
      </tr>`
    }).join('')}
    <tr><td colspan="6" style="border:1px solid #000;padding:2px 5px;text-align:center;font-weight:bold">RESULTADOS</td></tr>
    <tr>
      <td style="border:1px solid #000;padding:2px 5px">Flexiones promedio</td>
      <td colspan="2" style="border:1px solid #000;padding:2px 5px">${v(d.flex_prom_seco)}</td>
      <td style="border:1px solid #000;padding:2px 5px">Flexiones promedio</td>
      <td colspan="2" style="border:1px solid #000;padding:2px 5px">${v(d.flex_prom_hum)}</td>
    </tr>
    <tr>
      <td style="border:1px solid #000;padding:2px 5px">Daño presentado</td>
      <td colspan="2" style="border:1px solid #000;padding:2px 5px">${v(d.dano_seco)}</td>
      <td style="border:1px solid #000;padding:2px 5px">Daño presentado</td>
      <td colspan="2" style="border:1px solid #000;padding:2px 5px">${v(d.dano_hum)}</td>
    </tr>
  </table>`

  return `<div class="seccion no-break">
  <table style="margin-top:2px">
    <tr>
      <td colspan="3"><strong>NUMERO DE SOLICITUD:</strong> ${v(d.numero_solicitud)}</td>
      <td><strong>FECHA:</strong> ${v(d.fecha)}</td>
    </tr>
    <tr>
      <td colspan="4" class="center bold">NMX-S-051-1989 Numeral 7.1.1 Resistencia a la flexión</td>
    </tr>
    <tr>
      <td colspan="3" style="vertical-align:top;padding:4px">
        <table style="width:80%;border-collapse:collapse;margin-bottom:4px">
          <tr><td colspan="4" style="border:1px solid #000;padding:2px 5px;text-align:center;font-weight:bold">DATOS DEL ESPECIMEN</td></tr>
          <tr><td colspan="4" style="border:1px solid #000;padding:2px 5px">Tiempo de acondicionamiento: <strong>48 h</strong></td></tr>
          <tr>
            <td colspan="2" style="border:1px solid #000;padding:2px 5px;text-align:center;font-style:italic">Inicio del acondicionamiento</td>
            <td colspan="2" style="border:1px solid #000;padding:2px 5px;text-align:center;font-style:italic">Fin del acondicionamiento</td>
          </tr>
          <tr>
            <td style="border:1px solid #000;padding:2px 5px;width:25%">Hora</td>
            <td style="border:1px solid #000;padding:2px 5px;width:25%">${v(d.inicio_hora)}</td>
            <td style="border:1px solid #000;padding:2px 5px;width:25%">Hora</td>
            <td style="border:1px solid #000;padding:2px 5px;width:25%">${v(d.fin_hora)}</td>
          </tr>
          <tr>
            <td style="border:1px solid #000;padding:2px 5px">Temperatura °C</td>
            <td style="border:1px solid #000;padding:2px 5px">${v(d.inicio_temp)}</td>
            <td style="border:1px solid #000;padding:2px 5px">Temperatura °C</td>
            <td style="border:1px solid #000;padding:2px 5px">${v(d.fin_temp)}</td>
          </tr>
          <tr>
            <td style="border:1px solid #000;padding:2px 5px">Humedad Relativa<br>%HR</td>
            <td style="border:1px solid #000;padding:2px 5px">${v(d.inicio_hr)}</td>
            <td style="border:1px solid #000;padding:2px 5px">Humedad Relativa<br>%HR</td>
            <td style="border:1px solid #000;padding:2px 5px">${v(d.fin_hr)}</td>
          </tr>
          <tr>
            <td style="border:1px solid #000;padding:2px 5px">ID Termohigrómetro</td>
            <td style="border:1px solid #000;padding:2px 5px">${v(d.inicio_termo)}</td>
            <td style="border:1px solid #000;padding:2px 5px">ID Termohigrómetro</td>
            <td style="border:1px solid #000;padding:2px 5px">${v(d.fin_termo)}</td>
          </tr>
          <tr><td colspan="4" style="border:1px solid #000;padding:2px 5px;text-align:center;font-weight:bold">CONDICIONES DE ENSAYO</td></tr>
          <tr>
            <td colspan="2" style="border:1px solid #000;padding:2px 5px">Flexiones programadas en el flexómetro</td>
            <td colspan="2" style="border:1px solid #000;padding:2px 5px">${v(d.flexiones_programadas)}</td>
          </tr>
          <tr>
            <td colspan="2" rowspan="2" style="border:1px solid #000;padding:2px 5px;text-align:center">Prueba en húmedo</td>
            <td style="border:1px solid #000;padding:2px 5px">Tipo de agua utilizada</td>
            <td style="border:1px solid #000;padding:2px 5px">${v(d.tipo_agua)}</td>
          </tr>
          <tr>
            <td style="border:1px solid #000;padding:2px 5px">Tiempo de inmersión</td>
            <td style="border:1px solid #000;padding:2px 5px">${v(d.tiempo_inmersion)}</td>
          </tr>
        </table>
        ${evalTable}
      </td>
      <td style="vertical-align:top;padding:4px">
        Realizó:<br><br><br>${v(d.realizo)}<br><br>
        Autorizó:<br><br><br>${v(d.autorizo)}
      </td>
    </tr>
    ${v(d.observaciones) ? `<tr>
      <td colspan="4" style="text-align:justify">Notas: ${v(d.observaciones)}</td>
    </tr>` : ''}
  </table>
  </div>`
}

// PRUEBA ADICIONAL — nombre/fecha capturados por el usuario + documento Word renderizado
function bitAdicional(d: any): string {
  const notaDiv = (nota: string | null | undefined) =>
    nota ? `<div style="margin:4px 0 8px 0;padding:4px 6px;font-size:9pt;break-inside:avoid;page-break-inside:avoid">${DOMPurify.sanitize(nota)}</div>` : ''
  return `<div class="seccion no-break">
  <table><tr><td class="titulo-prueba">${v(d.nombre_prueba) || 'PRUEBA ADICIONAL'}</td></tr></table>
  <table style="margin-top:2px">
    <tr><td>FECHA:</td><td>${v(d.fecha)}</td><td>REALIZÓ:</td><td>${v(d.realizo)}</td></tr>
    <tr><td colspan="2">SUPERVISÓ: ${v(d.superviso)}</td><td colspan="2"></td></tr>
    <tr><td colspan="4" style="text-align:justify">OBSERVACIONES: ${v(d.observaciones)}</td></tr>
  </table>
  ${notaDiv(d.nota_doc)}
  </div>`
}

function renderBitacoraSeccion(nombre: string, data: any): string {
  if (nombre.includes('NMX-A-3801')) return bit3801(data)
  if (nombre.includes('NMX-A-109')) return bit109(data)
  if (nombre.includes('NMX-A-7211')) return bit7211(data)
  if (nombre.includes('NMX-A-134')) return bit134(data)
  if (nombre.includes('MET-7.2-11') || nombre.includes('7.2-11')) return bit711(data)
  if (nombre.includes('MET-7.2-12') || nombre.includes('7.2-12')) return bit712(data)
  if (nombre.includes('MET-7.2-19') || nombre.includes('7.2-19')) return bit719(data)
  if (nombre.includes('NMX-A-275')) return bit275(data)
  if (nombre.includes('NMX-A-172')) return bit172(data)
  if (nombre.includes('NMX-A-9073')) return bit9073(data)
  if (nombre.includes('NMX-A-4920')) return bit4920(data)
  if (nombre.includes('NMX-A-12945')) return bit12945(data)
  if (nombre.includes('NMX-A-083')) return bit083(data)
  if (nombre.includes('NMX-A-073')) return bit073(data)
  if (nombre.includes('NMX-A-105-D01')) return bit105d01(data)
  if (nombre.includes('NMX-A-105-B02')) return bit105b02(data)
  if (nombre.includes('NMX-A-105-C06') || (nombre.includes('NMX-A-105') && !nombre.includes('E04') && !nombre.includes('D01') && !nombre.includes('B02'))) return bit105(data)
  if (nombre.includes('NMX-A-105-E04') || nombre.includes('SUDOR')) return bit104(data)
  if (nombre.includes('NMX-A-059/1')) return bit059_1(data)
  if (nombre.includes('NMX-A-059/2') || nombre.includes('059/2') || nombre.includes('GRAB') || nombre.includes('Grab')) return bit059_2(data)
  if (nombre.includes('AATCC TM127') || nombre.includes('HYDROSTATIC')) return bitAATCC127(data)
  if (nombre.includes('NMX-S-051')) return bitS051(data)
  if (nombre.includes('NMX-A-5077')) return bit5077(data)
  if (nombre.includes('ANÁLISIS QUÍMICO') || nombre.includes('ANALISIS')) return bitAnalisis(data)
  if (nombre.includes('NMX-A-221')) return bitCuero221(data)
  if (nombre.includes('NMX-A-225')) return bitCuero225(data)
  if (nombre.includes('NMX-A-228')) return bitCuero228(data)
  if (nombre.includes('NMX-A-229')) return bitCuero229(data)
  if (nombre.includes('NMX-A-230')) return bitCuero230(data)
  if (nombre.includes('PRUEBA ADICIONAL')) return bitAdicional(data)
  // Fallback genérico
  return `<div class="seccion no-break">
  <table><tr><td class="titulo-prueba">${nombre}</td></tr></table>
  <table style="margin-top:2px">
    <tr><td>REALIZÓ: ${v(data.realizo)}</td><td>SUPERVISÓ: ${v(data.superviso)}</td></tr>
    <tr><td colspan="2" style="text-align:justify">OBSERVACIONES: ${v(data.observaciones)}</td></tr>
  </table>
  </div>`
}

// ─── Función principal ─────────────────────────────────────────────────────

export function generarBitacora(datos: DatosReporte): string {
  const { pedido, pruebas } = datos

  const filas = pruebas
    .map(p => {
      const es083 = p.nombre.includes('NMX-A-083')
      const rowClass = es083 ? ' class="bit083-row"' : ''
      return `<tr${rowClass}><td style="padding:0 30px 14px;border:none">${renderBitacoraSeccion(p.nombre, p.data)}</td></tr>`
    })
    .join('\n')

  return `<!DOCTYPE html>
<html lang="es">
<head>
<meta charset="UTF-8">
<title>Bitácora Labs - Folio ${v(pedido.folio)}</title>
<style>${CSS}</style>
</head>
<body>
<table style="width:100%;border-collapse:collapse">
  <tbody>
    <tr><td style="padding:18px 30px 10px;text-align:center;border:none">
      <p style="font-weight:bold;font-size:12pt">BITÁCORA DE LABORATORIO</p>
      <p>Folio de Sistema: ${v(pedido.folio)} &nbsp;|&nbsp; Orden: ${v(pedido.origen_numero)}</p>
    </td></tr>
  </tbody>
</table>
${pedido.nota_doc_cliente ? `<div class="pdf-embed" style="padding:0 30px 14px">${DOMPurify.sanitize(pedido.nota_doc_cliente)}</div>` : ''}
<table style="width:100%;border-collapse:collapse">
  <tbody>
    ${filas}
  </tbody>
</table>
</body>
</html>`
}
